"use strict";

var _excluded = ["timeoutInSeconds"],
  _excluded2 = ["grant_type", "redirect_uri", "client_id", "client_secret"],
  _excluded3 = ["grant_type", "client_id", "client_secret", "scope"],
  _excluded4 = ["grant_type", "client_id", "client_secret", "timeoutInSeconds"],
  _excluded5 = ["url", "authority", "client_id", "redirect_uri", "response_type", "scope", "state_data", "response_mode", "request_type", "client_secret", "nonce", "resource", "skipUserInfo", "extraQueryParams", "extraTokenParams"],
  _excluded6 = ["redirectMethod"],
  _excluded7 = ["popupWindowFeatures", "popupWindowTarget"],
  _excluded8 = ["silentRequestTimeoutInSeconds"],
  _excluded9 = ["silentRequestTimeoutInSeconds"],
  _excluded10 = ["redirectMethod"],
  _excluded11 = ["popupWindowFeatures", "popupWindowTarget"],
  _excluded12 = ["silentRequestTimeoutInSeconds"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AccessTokenEvents: function AccessTokenEvents() {
    return _AccessTokenEvents;
  },
  CheckSessionIFrame: function CheckSessionIFrame() {
    return _CheckSessionIFrame;
  },
  ErrorResponse: function ErrorResponse() {
    return _ErrorResponse;
  },
  ErrorTimeout: function ErrorTimeout() {
    return _ErrorTimeout;
  },
  InMemoryWebStorage: function InMemoryWebStorage() {
    return _InMemoryWebStorage;
  },
  Log: function Log() {
    return _Log;
  },
  Logger: function Logger() {
    return _Logger;
  },
  MetadataService: function MetadataService() {
    return _MetadataService;
  },
  OidcClient: function OidcClient() {
    return _OidcClient;
  },
  OidcClientSettingsStore: function OidcClientSettingsStore() {
    return _OidcClientSettingsStore;
  },
  SessionMonitor: function SessionMonitor() {
    return _SessionMonitor;
  },
  SigninResponse: function SigninResponse() {
    return _SigninResponse;
  },
  SigninState: function SigninState() {
    return _SigninState;
  },
  SignoutResponse: function SignoutResponse() {
    return _SignoutResponse;
  },
  State: function State() {
    return _State;
  },
  User: function User() {
    return _User;
  },
  UserManager: function UserManager() {
    return _UserManager;
  },
  UserManagerSettingsStore: function UserManagerSettingsStore() {
    return _UserManagerSettingsStore;
  },
  Version: function Version() {
    return _Version;
  },
  WebStorageStateStore: function WebStorageStateStore() {
    return _WebStorageStateStore;
  }
});
module.exports = __toCommonJS(src_exports);

// src/utils/CryptoUtils.ts
var import_core = __toESM(require("crypto-js/core.js"));
var import_sha256 = __toESM(require("crypto-js/sha256.js"));
var import_enc_base64 = __toESM(require("crypto-js/enc-base64.js"));
var import_enc_utf8 = __toESM(require("crypto-js/enc-utf8.js"));

// src/utils/Logger.ts
var nopLogger = {
  debug: function debug() {
    return void 0;
  },
  info: function info() {
    return void 0;
  },
  warn: function warn() {
    return void 0;
  },
  error: function error() {
    return void 0;
  }
};
var level;
var logger;
var _Log = /* @__PURE__ */function (Log2) {
  Log2[Log2["NONE"] = 0] = "NONE";
  Log2[Log2["ERROR"] = 1] = "ERROR";
  Log2[Log2["WARN"] = 2] = "WARN";
  Log2[Log2["INFO"] = 3] = "INFO";
  Log2[Log2["DEBUG"] = 4] = "DEBUG";
  return Log2;
}(_Log || {});
(function (Log2) {
  function reset() {
    level = 3 /* INFO */;
    logger = nopLogger;
  }
  Log2.reset = reset;
  function setLevel(value) {
    if (!(0 /* NONE */ <= value && value <= 4 /* DEBUG */)) {
      throw new Error("Invalid log level");
    }
    level = value;
  }
  Log2.setLevel = setLevel;
  function setLogger(value) {
    logger = value;
  }
  Log2.setLogger = setLogger;
})(_Log || (_Log = {}));
var _Logger = /*#__PURE__*/function () {
  function _Logger(_name) {
    _classCallCheck(this, _Logger);
    this._name = _name;
  }
  _createClass(_Logger, [{
    key: "debug",
    value: function debug() {
      if (level >= 4 /* DEBUG */) {
        var _logger;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (_logger = logger).debug.apply(_logger, [_Logger._format(this._name, this._method)].concat(args));
      }
    }
  }, {
    key: "info",
    value: function info() {
      if (level >= 3 /* INFO */) {
        var _logger2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_logger2 = logger).info.apply(_logger2, [_Logger._format(this._name, this._method)].concat(args));
      }
    }
  }, {
    key: "warn",
    value: function warn() {
      if (level >= 2 /* WARN */) {
        var _logger3;
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        (_logger3 = logger).warn.apply(_logger3, [_Logger._format(this._name, this._method)].concat(args));
      }
    }
  }, {
    key: "error",
    value: function error() {
      if (level >= 1 /* ERROR */) {
        var _logger4;
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        (_logger4 = logger).error.apply(_logger4, [_Logger._format(this._name, this._method)].concat(args));
      }
    }
  }, {
    key: "throw",
    value: function _throw(err) {
      this.error(err);
      throw err;
    }
  }, {
    key: "create",
    value: function create(method) {
      var methodLogger = Object.create(this);
      methodLogger._method = method;
      methodLogger.debug("begin");
      return methodLogger;
    }
  }], [{
    key: "createStatic",
    value: function createStatic(name, staticMethod) {
      var staticLogger = new _Logger("".concat(name, ".").concat(staticMethod));
      staticLogger.debug("begin");
      return staticLogger;
    }
  }, {
    key: "_format",
    value: function _format(name, method) {
      var prefix = "[".concat(name, "]");
      return method ? "".concat(prefix, " ").concat(method, ":") : prefix;
    }
    // helpers for static class methods
  }, {
    key: "debug",
    value: function debug(name) {
      if (level >= 4 /* DEBUG */) {
        var _logger5;
        for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
          args[_key5 - 1] = arguments[_key5];
        }
        (_logger5 = logger).debug.apply(_logger5, [_Logger._format(name)].concat(args));
      }
    }
  }, {
    key: "info",
    value: function info(name) {
      if (level >= 3 /* INFO */) {
        var _logger6;
        for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
          args[_key6 - 1] = arguments[_key6];
        }
        (_logger6 = logger).info.apply(_logger6, [_Logger._format(name)].concat(args));
      }
    }
  }, {
    key: "warn",
    value: function warn(name) {
      if (level >= 2 /* WARN */) {
        var _logger7;
        for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
          args[_key7 - 1] = arguments[_key7];
        }
        (_logger7 = logger).warn.apply(_logger7, [_Logger._format(name)].concat(args));
      }
    }
  }, {
    key: "error",
    value: function error(name) {
      if (level >= 1 /* ERROR */) {
        var _logger8;
        for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
          args[_key8 - 1] = arguments[_key8];
        }
        (_logger8 = logger).error.apply(_logger8, [_Logger._format(name)].concat(args));
      }
    }
  }]);
  return _Logger;
}();
_Log.reset();

// src/utils/CryptoUtils.ts
var UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var CryptoUtils = /*#__PURE__*/function () {
  function CryptoUtils() {
    _classCallCheck(this, CryptoUtils);
  }
  _createClass(CryptoUtils, null, [{
    key: "_randomWord",
    value: function _randomWord() {
      return import_core["default"].lib.WordArray.random(1).words[0];
    }
    /**
     * Generates RFC4122 version 4 guid
     */
  }, {
    key: "generateUUIDv4",
    value: function generateUUIDv4() {
      var uuid = UUID_V4_TEMPLATE.replace(/[018]/g, function (c) {
        return (+c ^ CryptoUtils._randomWord() & 15 >> +c / 4).toString(16);
      });
      return uuid.replace(/-/g, "");
    }
    /**
     * PKCE: Generate a code verifier
     */
  }, {
    key: "generateCodeVerifier",
    value: function generateCodeVerifier() {
      return CryptoUtils.generateUUIDv4() + CryptoUtils.generateUUIDv4() + CryptoUtils.generateUUIDv4();
    }
    /**
     * PKCE: Generate a code challenge
     */
  }, {
    key: "generateCodeChallenge",
    value: function generateCodeChallenge(code_verifier) {
      try {
        var hashed = (0, import_sha256["default"])(code_verifier);
        return import_enc_base64["default"].stringify(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
      } catch (err) {
        _Logger.error("CryptoUtils.generateCodeChallenge", err);
        throw err;
      }
    }
    /**
     * Generates a base64-encoded string for a basic auth header
     */
  }, {
    key: "generateBasicAuth",
    value: function generateBasicAuth(client_id, client_secret) {
      var basicAuth = import_enc_utf8["default"].parse([client_id, client_secret].join(":"));
      return import_enc_base64["default"].stringify(basicAuth);
    }
  }]);
  return CryptoUtils;
}();

// src/utils/Event.ts
var Event = /*#__PURE__*/function () {
  function Event(_name) {
    _classCallCheck(this, Event);
    this._name = _name;
    this._logger = new _Logger("Event('".concat(this._name, "')"));
    this._callbacks = [];
  }
  _createClass(Event, [{
    key: "addHandler",
    value: function addHandler(cb) {
      var _this = this;
      this._callbacks.push(cb);
      return function () {
        return _this.removeHandler(cb);
      };
    }
  }, {
    key: "removeHandler",
    value: function removeHandler(cb) {
      var idx = this._callbacks.lastIndexOf(cb);
      if (idx >= 0) {
        this._callbacks.splice(idx, 1);
      }
    }
  }, {
    key: "raise",
    value: function raise() {
      var _this$_logger;
      for (var _len9 = arguments.length, ev = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        ev[_key9] = arguments[_key9];
      }
      (_this$_logger = this._logger).debug.apply(_this$_logger, ["raise:"].concat(ev));
      var _iterator2 = _createForOfIteratorHelper(this._callbacks),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var cb = _step2.value;
          void cb.apply(void 0, ev);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
  return Event;
}();

// src/utils/JwtUtils.ts
var import_jwt_decode = __toESM(require("jwt-decode"));
var JwtUtils = /*#__PURE__*/function () {
  function JwtUtils() {
    _classCallCheck(this, JwtUtils);
  }
  _createClass(JwtUtils, null, [{
    key: "decode",
    value:
    // IMPORTANT: doesn't validate the token
    function decode(token) {
      try {
        return (0, import_jwt_decode["default"])(token);
      } catch (err) {
        _Logger.error("JwtUtils.decode", err);
        throw err;
      }
    }
  }]);
  return JwtUtils;
}();

// src/utils/PopupUtils.ts
var PopupUtils = /*#__PURE__*/function () {
  function PopupUtils() {
    _classCallCheck(this, PopupUtils);
  }
  _createClass(PopupUtils, null, [{
    key: "center",
    value:
    /**
     * Populates a map of window features with a placement centered in front of
     * the current window. If no explicit width is given, a default value is
     * binned into [800, 720, 600, 480, 360] based on the current window's width.
     */
    function center(_ref) {
      var features = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
      var _a, _b, _c;
      if (features.width == null) features.width = (_a = [800, 720, 600, 480].find(function (width) {
        return width <= window.outerWidth / 1.618;
      })) != null ? _a : 360;
      (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
      if (features.height != null) (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
      return features;
    }
  }, {
    key: "serialize",
    value: function serialize(features) {
      return Object.entries(features).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          value = _ref3[1];
        return value != null;
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];
        return "".concat(key, "=").concat(typeof value !== "boolean" ? value : value ? "yes" : "no");
      }).join(",");
    }
  }]);
  return PopupUtils;
}();

// src/utils/Timer.ts
var Timer = /*#__PURE__*/function (_Event) {
  _inherits(Timer, _Event);
  var _super = _createSuper(Timer);
  function Timer() {
    var _thisSuper, _this2;
    _classCallCheck(this, Timer);
    _this2 = _super.apply(this, arguments);
    _this2._logger = new _Logger("Timer('".concat(_this2._name, "')"));
    _this2._timerHandle = null;
    _this2._expiration = 0;
    _this2._callback = function () {
      var diff = _this2._expiration - Timer.getEpochTime();
      _this2._logger.debug("timer completes in", diff);
      if (_this2._expiration <= Timer.getEpochTime()) {
        _this2.cancel();
        _get((_thisSuper = _assertThisInitialized(_this2), _getPrototypeOf(Timer.prototype)), "raise", _thisSuper).call(_thisSuper);
      }
    };
    return _this2;
  }
  // get the time
  _createClass(Timer, [{
    key: "init",
    value: function init(durationInSeconds) {
      var logger2 = this._logger.create("init");
      durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
      var expiration = Timer.getEpochTime() + durationInSeconds;
      if (this.expiration === expiration && this._timerHandle) {
        logger2.debug("skipping since already initialized for expiration at", this.expiration);
        return;
      }
      this.cancel();
      logger2.debug("using duration", durationInSeconds);
      this._expiration = expiration;
      var timerDurationInSeconds = Math.min(durationInSeconds, 5);
      this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
    }
  }, {
    key: "expiration",
    get: function get() {
      return this._expiration;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._logger.create("cancel");
      if (this._timerHandle) {
        clearInterval(this._timerHandle);
        this._timerHandle = null;
      }
    }
  }], [{
    key: "getEpochTime",
    value: function getEpochTime() {
      return Math.floor(Date.now() / 1e3);
    }
  }]);
  return Timer;
}(Event);

// src/utils/UrlUtils.ts
var UrlUtils = /*#__PURE__*/function () {
  function UrlUtils() {
    _classCallCheck(this, UrlUtils);
  }
  _createClass(UrlUtils, null, [{
    key: "readParams",
    value: function readParams(url) {
      var responseMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "query";
      if (!url) throw new TypeError("Invalid URL");
      var parsedUrl = new URL(url, window.location.origin);
      var params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
      return new URLSearchParams(params.slice(1));
    }
  }]);
  return UrlUtils;
}();

// src/errors/ErrorResponse.ts
var _ErrorResponse = /*#__PURE__*/function (_Error) {
  _inherits(_ErrorResponse, _Error);
  var _super2 = _createSuper(_ErrorResponse);
  function _ErrorResponse(args, form) {
    var _this3;
    _classCallCheck(this, _ErrorResponse);
    var _a, _b, _c;
    _this3 = _super2.call(this, args.error_description || args.error || "");
    _this3.form = form;
    /** Marker to detect class: "ErrorResponse" */
    _this3.name = "ErrorResponse";
    if (!args.error) {
      _Logger.error("ErrorResponse", "No error passed");
      throw new Error("No error passed");
    }
    _this3.error = args.error;
    _this3.error_description = (_a = args.error_description) != null ? _a : null;
    _this3.error_uri = (_b = args.error_uri) != null ? _b : null;
    _this3.state = args.userState;
    _this3.session_state = (_c = args.session_state) != null ? _c : null;
    return _this3;
  }
  return _createClass(_ErrorResponse);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// src/errors/ErrorTimeout.ts
var _ErrorTimeout = /*#__PURE__*/function (_Error2) {
  _inherits(_ErrorTimeout, _Error2);
  var _super3 = _createSuper(_ErrorTimeout);
  function _ErrorTimeout(message) {
    var _this4;
    _classCallCheck(this, _ErrorTimeout);
    _this4 = _super3.call(this, message);
    /** Marker to detect class: "ErrorTimeout" */
    _this4.name = "ErrorTimeout";
    return _this4;
  }
  return _createClass(_ErrorTimeout);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// src/AccessTokenEvents.ts
var _AccessTokenEvents = /*#__PURE__*/function () {
  function _AccessTokenEvents(args) {
    _classCallCheck(this, _AccessTokenEvents);
    this._logger = new _Logger("AccessTokenEvents");
    this._expiringTimer = new Timer("Access token expiring");
    this._expiredTimer = new Timer("Access token expired");
    this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
  }
  _createClass(_AccessTokenEvents, [{
    key: "load",
    value: function load(container) {
      var logger2 = this._logger.create("load");
      if (container.access_token && container.expires_in !== void 0) {
        var duration = container.expires_in;
        logger2.debug("access token present, remaining duration:", duration);
        if (duration > 0) {
          var expiring = duration - this._expiringNotificationTimeInSeconds;
          if (expiring <= 0) {
            expiring = 1;
          }
          logger2.debug("registering expiring timer, raising in", expiring, "seconds");
          this._expiringTimer.init(expiring);
        } else {
          logger2.debug("canceling existing expiring timer because we're past expiration.");
          this._expiringTimer.cancel();
        }
        var expired = duration + 1;
        logger2.debug("registering expired timer, raising in", expired, "seconds");
        this._expiredTimer.init(expired);
      } else {
        this._expiringTimer.cancel();
        this._expiredTimer.cancel();
      }
    }
  }, {
    key: "unload",
    value: function unload() {
      this._logger.debug("unload: canceling existing access token timers");
      this._expiringTimer.cancel();
      this._expiredTimer.cancel();
    }
    /**
     * Add callback: Raised prior to the access token expiring.
     */
  }, {
    key: "addAccessTokenExpiring",
    value: function addAccessTokenExpiring(cb) {
      return this._expiringTimer.addHandler(cb);
    }
    /**
     * Remove callback: Raised prior to the access token expiring.
     */
  }, {
    key: "removeAccessTokenExpiring",
    value: function removeAccessTokenExpiring(cb) {
      this._expiringTimer.removeHandler(cb);
    }
    /**
     * Add callback: Raised after the access token has expired.
     */
  }, {
    key: "addAccessTokenExpired",
    value: function addAccessTokenExpired(cb) {
      return this._expiredTimer.addHandler(cb);
    }
    /**
     * Remove callback: Raised after the access token has expired.
     */
  }, {
    key: "removeAccessTokenExpired",
    value: function removeAccessTokenExpired(cb) {
      this._expiredTimer.removeHandler(cb);
    }
  }]);
  return _AccessTokenEvents;
}();

// src/CheckSessionIFrame.ts
var _CheckSessionIFrame = /*#__PURE__*/function () {
  function _CheckSessionIFrame(_callback, _client_id, url, _intervalInSeconds, _stopOnError) {
    var _this5 = this;
    _classCallCheck(this, _CheckSessionIFrame);
    this._callback = _callback;
    this._client_id = _client_id;
    this._intervalInSeconds = _intervalInSeconds;
    this._stopOnError = _stopOnError;
    this._logger = new _Logger("CheckSessionIFrame");
    this._timer = null;
    this._session_state = null;
    this._message = function (e) {
      if (e.origin === _this5._frame_origin && e.source === _this5._frame.contentWindow) {
        if (e.data === "error") {
          _this5._logger.error("error message from check session op iframe");
          if (_this5._stopOnError) {
            _this5.stop();
          }
        } else if (e.data === "changed") {
          _this5._logger.debug("changed message from check session op iframe");
          _this5.stop();
          void _this5._callback();
        } else {
          _this5._logger.debug(e.data + " message from check session op iframe");
        }
      }
    };
    var parsedUrl = new URL(url);
    this._frame_origin = parsedUrl.origin;
    this._frame = window.document.createElement("iframe");
    this._frame.style.visibility = "hidden";
    this._frame.style.position = "fixed";
    this._frame.style.left = "-1000px";
    this._frame.style.top = "0";
    this._frame.width = "0";
    this._frame.height = "0";
    this._frame.src = parsedUrl.href;
  }
  _createClass(_CheckSessionIFrame, [{
    key: "load",
    value: function load() {
      var _this6 = this;
      return new Promise(function (resolve) {
        _this6._frame.onload = function () {
          resolve();
        };
        window.document.body.appendChild(_this6._frame);
        window.addEventListener("message", _this6._message, false);
      });
    }
  }, {
    key: "start",
    value: function start(session_state) {
      var _this7 = this;
      if (this._session_state === session_state) {
        return;
      }
      this._logger.create("start");
      this.stop();
      this._session_state = session_state;
      var send = function send() {
        if (!_this7._frame.contentWindow || !_this7._session_state) {
          return;
        }
        _this7._frame.contentWindow.postMessage(_this7._client_id + " " + _this7._session_state, _this7._frame_origin);
      };
      send();
      this._timer = setInterval(send, this._intervalInSeconds * 1e3);
    }
  }, {
    key: "stop",
    value: function stop() {
      this._logger.create("stop");
      this._session_state = null;
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }
  }]);
  return _CheckSessionIFrame;
}();

// src/InMemoryWebStorage.ts
var _InMemoryWebStorage = /*#__PURE__*/function () {
  function _InMemoryWebStorage() {
    _classCallCheck(this, _InMemoryWebStorage);
    this._logger = new _Logger("InMemoryWebStorage");
    this._data = {};
  }
  _createClass(_InMemoryWebStorage, [{
    key: "clear",
    value: function clear() {
      this._logger.create("clear");
      this._data = {};
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      this._logger.create("getItem('".concat(key, "')"));
      return this._data[key];
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this._logger.create("setItem('".concat(key, "')"));
      this._data[key] = value;
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      this._logger.create("removeItem('".concat(key, "')"));
      delete this._data[key];
    }
  }, {
    key: "length",
    get: function get() {
      return Object.getOwnPropertyNames(this._data).length;
    }
  }, {
    key: "key",
    value: function key(index) {
      return Object.getOwnPropertyNames(this._data)[index];
    }
  }]);
  return _InMemoryWebStorage;
}();

// src/JsonService.ts
var JsonService = /*#__PURE__*/function () {
  function JsonService() {
    var _this$_contentTypes;
    var additionalContentTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _jwtHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, JsonService);
    this._jwtHandler = _jwtHandler;
    this._logger = new _Logger("JsonService");
    this._contentTypes = [];
    (_this$_contentTypes = this._contentTypes).push.apply(_this$_contentTypes, _toConsumableArray(additionalContentTypes).concat(["application/json"]));
    if (_jwtHandler) {
      this._contentTypes.push("application/jwt");
    }
  }
  _createClass(JsonService, [{
    key: "fetchWithTimeout",
    value: function () {
      var _fetchWithTimeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(input) {
        var init,
          timeoutInSeconds,
          initFetch,
          controller,
          timeoutId,
          response,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              init = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              timeoutInSeconds = init.timeoutInSeconds, initFetch = _objectWithoutProperties(init, _excluded);
              if (timeoutInSeconds) {
                _context.next = 6;
                break;
              }
              _context.next = 5;
              return fetch(input, initFetch);
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
              controller = new AbortController();
              timeoutId = setTimeout(function () {
                return controller.abort();
              }, timeoutInSeconds * 1e3);
              _context.prev = 8;
              _context.next = 11;
              return fetch(input, _objectSpread(_objectSpread({}, init), {}, {
                signal: controller.signal
              }));
            case 11:
              response = _context.sent;
              return _context.abrupt("return", response);
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](8);
              if (!(_context.t0 instanceof DOMException && _context.t0.name === "AbortError")) {
                _context.next = 19;
                break;
              }
              throw new _ErrorTimeout("Network timed out");
            case 19:
              throw _context.t0;
            case 20:
              _context.prev = 20;
              clearTimeout(timeoutId);
              return _context.finish(20);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[8, 15, 20, 23]]);
      }));
      function fetchWithTimeout(_x2) {
        return _fetchWithTimeout.apply(this, arguments);
      }
      return fetchWithTimeout;
    }()
  }, {
    key: "getJson",
    value: function () {
      var _getJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url) {
        var _ref6,
          token,
          credentials,
          logger2,
          headers,
          response,
          contentType,
          json,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref6 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, token = _ref6.token, credentials = _ref6.credentials;
              logger2 = this._logger.create("getJson");
              headers = {
                "Accept": this._contentTypes.join(", ")
              };
              if (token) {
                logger2.debug("token passed, setting Authorization header");
                headers["Authorization"] = "Bearer " + token;
              }
              _context2.prev = 4;
              logger2.debug("url:", url);
              _context2.next = 8;
              return this.fetchWithTimeout(url, {
                method: "GET",
                headers: headers,
                credentials: credentials
              });
            case 8:
              response = _context2.sent;
              _context2.next = 15;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              logger2.error("Network Error");
              throw _context2.t0;
            case 15:
              logger2.debug("HTTP response received, status", response.status);
              contentType = response.headers.get("Content-Type");
              if (contentType && !this._contentTypes.find(function (item) {
                return contentType.startsWith(item);
              })) {
                logger2["throw"](new Error("Invalid response Content-Type: ".concat(contentType != null ? contentType : "undefined", ", from URL: ").concat(url)));
              }
              if (!(response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt")))) {
                _context2.next = 26;
                break;
              }
              _context2.t1 = this;
              _context2.next = 22;
              return response.text();
            case 22:
              _context2.t2 = _context2.sent;
              _context2.next = 25;
              return _context2.t1._jwtHandler.call(_context2.t1, _context2.t2);
            case 25:
              return _context2.abrupt("return", _context2.sent);
            case 26:
              _context2.prev = 26;
              _context2.next = 29;
              return response.json();
            case 29:
              json = _context2.sent;
              _context2.next = 38;
              break;
            case 32:
              _context2.prev = 32;
              _context2.t3 = _context2["catch"](26);
              logger2.error("Error parsing JSON response", _context2.t3);
              if (!response.ok) {
                _context2.next = 37;
                break;
              }
              throw _context2.t3;
            case 37:
              throw new Error("".concat(response.statusText, " (").concat(response.status, ")"));
            case 38:
              if (response.ok) {
                _context2.next = 43;
                break;
              }
              logger2.error("Error from server:", json);
              if (!json.error) {
                _context2.next = 42;
                break;
              }
              throw new _ErrorResponse(json);
            case 42:
              throw new Error("".concat(response.statusText, " (").concat(response.status, "): ").concat(JSON.stringify(json)));
            case 43:
              return _context2.abrupt("return", json);
            case 44:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11], [26, 32]]);
      }));
      function getJson(_x3) {
        return _getJson.apply(this, arguments);
      }
      return getJson;
    }()
  }, {
    key: "postForm",
    value: function () {
      var _postForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(url, _ref7) {
        var body, basicAuth, timeoutInSeconds, initCredentials, logger2, headers, response, contentType, responseText, json;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              body = _ref7.body, basicAuth = _ref7.basicAuth, timeoutInSeconds = _ref7.timeoutInSeconds, initCredentials = _ref7.initCredentials;
              logger2 = this._logger.create("postForm");
              headers = {
                "Accept": this._contentTypes.join(", "),
                "Content-Type": "application/x-www-form-urlencoded"
              };
              if (basicAuth !== void 0) {
                headers["Authorization"] = "Basic " + basicAuth;
              }
              _context3.prev = 4;
              logger2.debug("url:", url);
              _context3.next = 8;
              return this.fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: body,
                timeoutInSeconds: timeoutInSeconds,
                credentials: initCredentials
              });
            case 8:
              response = _context3.sent;
              _context3.next = 15;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              logger2.error("Network error");
              throw _context3.t0;
            case 15:
              logger2.debug("HTTP response received, status", response.status);
              contentType = response.headers.get("Content-Type");
              if (!(contentType && !this._contentTypes.find(function (item) {
                return contentType.startsWith(item);
              }))) {
                _context3.next = 19;
                break;
              }
              throw new Error("Invalid response Content-Type: ".concat(contentType != null ? contentType : "undefined", ", from URL: ").concat(url));
            case 19:
              _context3.next = 21;
              return response.text();
            case 21:
              responseText = _context3.sent;
              json = {};
              if (!responseText) {
                _context3.next = 34;
                break;
              }
              _context3.prev = 24;
              json = JSON.parse(responseText);
              _context3.next = 34;
              break;
            case 28:
              _context3.prev = 28;
              _context3.t1 = _context3["catch"](24);
              logger2.error("Error parsing JSON response", _context3.t1);
              if (!response.ok) {
                _context3.next = 33;
                break;
              }
              throw _context3.t1;
            case 33:
              throw new Error("".concat(response.statusText, " (").concat(response.status, ")"));
            case 34:
              if (response.ok) {
                _context3.next = 39;
                break;
              }
              logger2.error("Error from server:", json);
              if (!json.error) {
                _context3.next = 38;
                break;
              }
              throw new _ErrorResponse(json, body);
            case 38:
              throw new Error("".concat(response.statusText, " (").concat(response.status, "): ").concat(JSON.stringify(json)));
            case 39:
              return _context3.abrupt("return", json);
            case 40:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11], [24, 28]]);
      }));
      function postForm(_x4, _x5) {
        return _postForm.apply(this, arguments);
      }
      return postForm;
    }()
  }]);
  return JsonService;
}();

// src/MetadataService.ts
var _MetadataService = /*#__PURE__*/function () {
  function _MetadataService(_settings) {
    _classCallCheck(this, _MetadataService);
    this._settings = _settings;
    this._logger = new _Logger("MetadataService");
    this._jsonService = new JsonService(["application/jwk-set+json"]);
    this._signingKeys = null;
    this._metadata = null;
    this._metadataUrl = this._settings.metadataUrl;
    if (this._settings.signingKeys) {
      this._logger.debug("using signingKeys from settings");
      this._signingKeys = this._settings.signingKeys;
    }
    if (this._settings.metadata) {
      this._logger.debug("using metadata from settings");
      this._metadata = this._settings.metadata;
    }
    if (this._settings.fetchRequestCredentials) {
      this._logger.debug("using fetchRequestCredentials from settings");
      this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
    }
  }
  _createClass(_MetadataService, [{
    key: "resetSigningKeys",
    value: function resetSigningKeys() {
      this._signingKeys = null;
    }
  }, {
    key: "getMetadata",
    value: function () {
      var _getMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var logger2, metadata;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              logger2 = this._logger.create("getMetadata");
              if (!this._metadata) {
                _context4.next = 4;
                break;
              }
              logger2.debug("using cached values");
              return _context4.abrupt("return", this._metadata);
            case 4:
              if (this._metadataUrl) {
                _context4.next = 7;
                break;
              }
              logger2["throw"](new Error("No authority or metadataUrl configured on settings"));
              throw null;
            case 7:
              logger2.debug("getting metadata from", this._metadataUrl);
              _context4.next = 10;
              return this._jsonService.getJson(this._metadataUrl, {
                credentials: this._fetchRequestCredentials
              });
            case 10:
              metadata = _context4.sent;
              logger2.debug("merging remote JSON with seed metadata");
              this._metadata = Object.assign({}, this._settings.metadataSeed, metadata);
              return _context4.abrupt("return", this._metadata);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getMetadata() {
        return _getMetadata.apply(this, arguments);
      }
      return getMetadata;
    }()
  }, {
    key: "getIssuer",
    value: function getIssuer() {
      return this._getMetadataProperty("issuer");
    }
  }, {
    key: "getAuthorizationEndpoint",
    value: function getAuthorizationEndpoint() {
      return this._getMetadataProperty("authorization_endpoint");
    }
  }, {
    key: "getUserInfoEndpoint",
    value: function getUserInfoEndpoint() {
      return this._getMetadataProperty("userinfo_endpoint");
    }
  }, {
    key: "getTokenEndpoint",
    value: function getTokenEndpoint() {
      var optional = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this._getMetadataProperty("token_endpoint", optional);
    }
  }, {
    key: "getCheckSessionIframe",
    value: function getCheckSessionIframe() {
      return this._getMetadataProperty("check_session_iframe", true);
    }
  }, {
    key: "getEndSessionEndpoint",
    value: function getEndSessionEndpoint() {
      return this._getMetadataProperty("end_session_endpoint", true);
    }
  }, {
    key: "getRevocationEndpoint",
    value: function getRevocationEndpoint() {
      var optional = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this._getMetadataProperty("revocation_endpoint", optional);
    }
  }, {
    key: "getKeysEndpoint",
    value: function getKeysEndpoint() {
      var optional = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this._getMetadataProperty("jwks_uri", optional);
    }
  }, {
    key: "_getMetadataProperty",
    value: function () {
      var _getMetadataProperty2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(name) {
        var optional,
          logger2,
          metadata,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              optional = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
              logger2 = this._logger.create("_getMetadataProperty('".concat(name, "')"));
              _context5.next = 4;
              return this.getMetadata();
            case 4:
              metadata = _context5.sent;
              logger2.debug("resolved");
              if (!(metadata[name] === void 0)) {
                _context5.next = 11;
                break;
              }
              if (!(optional === true)) {
                _context5.next = 10;
                break;
              }
              logger2.warn("Metadata does not contain optional property");
              return _context5.abrupt("return", void 0);
            case 10:
              logger2["throw"](new Error("Metadata does not contain property " + name));
            case 11:
              return _context5.abrupt("return", metadata[name]);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function _getMetadataProperty(_x6) {
        return _getMetadataProperty2.apply(this, arguments);
      }
      return _getMetadataProperty;
    }()
  }, {
    key: "getSigningKeys",
    value: function () {
      var _getSigningKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var logger2, jwks_uri, keySet;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              logger2 = this._logger.create("getSigningKeys");
              if (!this._signingKeys) {
                _context6.next = 4;
                break;
              }
              logger2.debug("returning signingKeys from cache");
              return _context6.abrupt("return", this._signingKeys);
            case 4:
              _context6.next = 6;
              return this.getKeysEndpoint(false);
            case 6:
              jwks_uri = _context6.sent;
              logger2.debug("got jwks_uri", jwks_uri);
              _context6.next = 10;
              return this._jsonService.getJson(jwks_uri);
            case 10:
              keySet = _context6.sent;
              logger2.debug("got key set", keySet);
              if (Array.isArray(keySet.keys)) {
                _context6.next = 15;
                break;
              }
              logger2["throw"](new Error("Missing keys on keyset"));
              throw null;
            case 15:
              this._signingKeys = keySet.keys;
              return _context6.abrupt("return", this._signingKeys);
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getSigningKeys() {
        return _getSigningKeys.apply(this, arguments);
      }
      return getSigningKeys;
    }()
  }]);
  return _MetadataService;
}();

// src/WebStorageStateStore.ts
var _WebStorageStateStore = /*#__PURE__*/function () {
  function _WebStorageStateStore() {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref8$prefix = _ref8.prefix,
      prefix = _ref8$prefix === void 0 ? "oidc." : _ref8$prefix,
      _ref8$store = _ref8.store,
      store = _ref8$store === void 0 ? localStorage : _ref8$store;
    _classCallCheck(this, _WebStorageStateStore);
    this._logger = new _Logger("WebStorageStateStore");
    this._store = store;
    this._prefix = prefix;
  }
  _createClass(_WebStorageStateStore, [{
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(key, value) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this._logger.create("set('".concat(key, "')"));
              key = this._prefix + key;
              _context7.next = 4;
              return this._store.setItem(key, value);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function set(_x7, _x8) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }, {
    key: "get",
    value: function () {
      var _get2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(key) {
        var item;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this._logger.create("get('".concat(key, "')"));
              key = this._prefix + key;
              _context8.next = 4;
              return this._store.getItem(key);
            case 4:
              item = _context8.sent;
              return _context8.abrupt("return", item);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function get(_x9) {
        return _get2.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(key) {
        var item;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this._logger.create("remove('".concat(key, "')"));
              key = this._prefix + key;
              _context9.next = 4;
              return this._store.getItem(key);
            case 4:
              item = _context9.sent;
              _context9.next = 7;
              return this._store.removeItem(key);
            case 7:
              return _context9.abrupt("return", item);
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function remove(_x10) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "getAllKeys",
    value: function () {
      var _getAllKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var len, keys, index, key;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this._logger.create("getAllKeys");
              _context10.next = 3;
              return this._store.length;
            case 3:
              len = _context10.sent;
              keys = [];
              index = 0;
            case 6:
              if (!(index < len)) {
                _context10.next = 14;
                break;
              }
              _context10.next = 9;
              return this._store.key(index);
            case 9:
              key = _context10.sent;
              if (key && key.indexOf(this._prefix) === 0) {
                keys.push(key.substr(this._prefix.length));
              }
            case 11:
              index++;
              _context10.next = 6;
              break;
            case 14:
              return _context10.abrupt("return", keys);
            case 15:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getAllKeys() {
        return _getAllKeys.apply(this, arguments);
      }
      return getAllKeys;
    }()
  }]);
  return _WebStorageStateStore;
}();

// src/OidcClientSettings.ts
var DefaultResponseType = "code";
var DefaultScope = "openid";
var DefaultClientAuthentication = "client_secret_post";
var DefaultResponseMode = "query";
var DefaultStaleStateAgeInSeconds = 60 * 15;
var DefaultClockSkewInSeconds = 60 * 5;
var _OidcClientSettingsStore = /*#__PURE__*/_createClass(function _OidcClientSettingsStore(_ref9) {
  var authority = _ref9.authority,
    metadataUrl = _ref9.metadataUrl,
    metadata = _ref9.metadata,
    signingKeys = _ref9.signingKeys,
    metadataSeed = _ref9.metadataSeed,
    client_id = _ref9.client_id,
    client_secret = _ref9.client_secret,
    _ref9$response_type = _ref9.response_type,
    response_type = _ref9$response_type === void 0 ? DefaultResponseType : _ref9$response_type,
    _ref9$scope = _ref9.scope,
    scope = _ref9$scope === void 0 ? DefaultScope : _ref9$scope,
    redirect_uri = _ref9.redirect_uri,
    post_logout_redirect_uri = _ref9.post_logout_redirect_uri,
    _ref9$client_authenti = _ref9.client_authentication,
    client_authentication = _ref9$client_authenti === void 0 ? DefaultClientAuthentication : _ref9$client_authenti,
    prompt = _ref9.prompt,
    display = _ref9.display,
    max_age = _ref9.max_age,
    ui_locales = _ref9.ui_locales,
    acr_values = _ref9.acr_values,
    resource = _ref9.resource,
    _ref9$response_mode = _ref9.response_mode,
    response_mode = _ref9$response_mode === void 0 ? DefaultResponseMode : _ref9$response_mode,
    _ref9$filterProtocolC = _ref9.filterProtocolClaims,
    filterProtocolClaims = _ref9$filterProtocolC === void 0 ? true : _ref9$filterProtocolC,
    _ref9$loadUserInfo = _ref9.loadUserInfo,
    loadUserInfo = _ref9$loadUserInfo === void 0 ? false : _ref9$loadUserInfo,
    _ref9$staleStateAgeIn = _ref9.staleStateAgeInSeconds,
    staleStateAgeInSeconds = _ref9$staleStateAgeIn === void 0 ? DefaultStaleStateAgeInSeconds : _ref9$staleStateAgeIn,
    _ref9$clockSkewInSeco = _ref9.clockSkewInSeconds,
    clockSkewInSeconds = _ref9$clockSkewInSeco === void 0 ? DefaultClockSkewInSeconds : _ref9$clockSkewInSeco,
    _ref9$userInfoJwtIssu = _ref9.userInfoJwtIssuer,
    userInfoJwtIssuer = _ref9$userInfoJwtIssu === void 0 ? "OP" : _ref9$userInfoJwtIssu,
    _ref9$mergeClaims = _ref9.mergeClaims,
    mergeClaims = _ref9$mergeClaims === void 0 ? false : _ref9$mergeClaims,
    stateStore = _ref9.stateStore,
    refreshTokenCredentials = _ref9.refreshTokenCredentials,
    revokeTokenAdditionalContentTypes = _ref9.revokeTokenAdditionalContentTypes,
    fetchRequestCredentials = _ref9.fetchRequestCredentials,
    refreshTokenAllowedScope = _ref9.refreshTokenAllowedScope,
    _ref9$extraQueryParam = _ref9.extraQueryParams,
    extraQueryParams = _ref9$extraQueryParam === void 0 ? {} : _ref9$extraQueryParam,
    _ref9$extraTokenParam = _ref9.extraTokenParams,
    extraTokenParams = _ref9$extraTokenParam === void 0 ? {} : _ref9$extraTokenParam;
  _classCallCheck(this, _OidcClientSettingsStore);
  this.authority = authority;
  if (metadataUrl) {
    this.metadataUrl = metadataUrl;
  } else {
    this.metadataUrl = authority;
    if (authority) {
      if (!this.metadataUrl.endsWith("/")) {
        this.metadataUrl += "/";
      }
      this.metadataUrl += ".well-known/openid-configuration";
    }
  }
  this.metadata = metadata;
  this.metadataSeed = metadataSeed;
  this.signingKeys = signingKeys;
  this.client_id = client_id;
  this.client_secret = client_secret;
  this.response_type = response_type;
  this.scope = scope;
  this.redirect_uri = redirect_uri;
  this.post_logout_redirect_uri = post_logout_redirect_uri;
  this.client_authentication = client_authentication;
  this.prompt = prompt;
  this.display = display;
  this.max_age = max_age;
  this.ui_locales = ui_locales;
  this.acr_values = acr_values;
  this.resource = resource;
  this.response_mode = response_mode;
  this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
  this.loadUserInfo = !!loadUserInfo;
  this.staleStateAgeInSeconds = staleStateAgeInSeconds;
  this.clockSkewInSeconds = clockSkewInSeconds;
  this.userInfoJwtIssuer = userInfoJwtIssuer;
  this.mergeClaims = !!mergeClaims;
  this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
  if (fetchRequestCredentials && refreshTokenCredentials) {
    console.warn("Both fetchRequestCredentials and refreshTokenCredentials is set. Only fetchRequestCredentials will be used.");
  }
  this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : refreshTokenCredentials ? refreshTokenCredentials : "same-origin";
  if (stateStore) {
    this.stateStore = stateStore;
  } else {
    var store = typeof window !== "undefined" ? window.localStorage : new _InMemoryWebStorage();
    this.stateStore = new _WebStorageStateStore({
      store: store
    });
  }
  this.refreshTokenAllowedScope = refreshTokenAllowedScope;
  this.extraQueryParams = extraQueryParams;
  this.extraTokenParams = extraTokenParams;
});

// src/UserInfoService.ts
var UserInfoService = /*#__PURE__*/function () {
  function UserInfoService(_settings, _metadataService) {
    var _this8 = this;
    _classCallCheck(this, UserInfoService);
    this._settings = _settings;
    this._metadataService = _metadataService;
    this._logger = new _Logger("UserInfoService");
    this._getClaimsFromJwt = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(responseText) {
        var logger2, payload;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              logger2 = _this8._logger.create("_getClaimsFromJwt");
              _context11.prev = 1;
              payload = JwtUtils.decode(responseText);
              logger2.debug("JWT decoding successful");
              return _context11.abrupt("return", payload);
            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](1);
              logger2.error("Error parsing JWT response");
              throw _context11.t0;
            case 11:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[1, 7]]);
      }));
      return function (_x11) {
        return _ref10.apply(this, arguments);
      };
    }();
    this._jsonService = new JsonService(void 0, this._getClaimsFromJwt);
  }
  _createClass(UserInfoService, [{
    key: "getClaims",
    value: function () {
      var _getClaims = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(token) {
        var logger2, url, claims;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              logger2 = this._logger.create("getClaims");
              if (!token) {
                this._logger["throw"](new Error("No token passed"));
              }
              _context12.next = 4;
              return this._metadataService.getUserInfoEndpoint();
            case 4:
              url = _context12.sent;
              logger2.debug("got userinfo url", url);
              _context12.next = 8;
              return this._jsonService.getJson(url, {
                token: token,
                credentials: this._settings.fetchRequestCredentials
              });
            case 8:
              claims = _context12.sent;
              logger2.debug("got claims", claims);
              return _context12.abrupt("return", claims);
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getClaims(_x12) {
        return _getClaims.apply(this, arguments);
      }
      return getClaims;
    }()
  }]);
  return UserInfoService;
}();

// src/TokenClient.ts
var TokenClient = /*#__PURE__*/function () {
  function TokenClient(_settings, _metadataService) {
    _classCallCheck(this, TokenClient);
    this._settings = _settings;
    this._metadataService = _metadataService;
    this._logger = new _Logger("TokenClient");
    this._jsonService = new JsonService(this._settings.revokeTokenAdditionalContentTypes);
  }
  _createClass(TokenClient, [{
    key: "exchangeCode",
    value: function () {
      var _exchangeCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref11) {
        var _ref11$grant_type, grant_type, _ref11$redirect_uri, redirect_uri, _ref11$client_id, client_id, _ref11$client_secret, client_secret, args, logger2, params, _i2, _Object$entries, _Object$entries$_i, key, value, basicAuth, url, response;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _ref11$grant_type = _ref11.grant_type, grant_type = _ref11$grant_type === void 0 ? "authorization_code" : _ref11$grant_type, _ref11$redirect_uri = _ref11.redirect_uri, redirect_uri = _ref11$redirect_uri === void 0 ? this._settings.redirect_uri : _ref11$redirect_uri, _ref11$client_id = _ref11.client_id, client_id = _ref11$client_id === void 0 ? this._settings.client_id : _ref11$client_id, _ref11$client_secret = _ref11.client_secret, client_secret = _ref11$client_secret === void 0 ? this._settings.client_secret : _ref11$client_secret, args = _objectWithoutProperties(_ref11, _excluded2);
              logger2 = this._logger.create("exchangeCode");
              if (!client_id) {
                logger2["throw"](new Error("A client_id is required"));
              }
              if (!redirect_uri) {
                logger2["throw"](new Error("A redirect_uri is required"));
              }
              if (!args.code) {
                logger2["throw"](new Error("A code is required"));
              }
              if (!args.code_verifier) {
                logger2["throw"](new Error("A code_verifier is required"));
              }
              params = new URLSearchParams({
                grant_type: grant_type,
                redirect_uri: redirect_uri
              });
              for (_i2 = 0, _Object$entries = Object.entries(args); _i2 < _Object$entries.length; _i2++) {
                _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                if (value != null) {
                  params.set(key, value);
                }
              }
              _context13.t0 = this._settings.client_authentication;
              _context13.next = _context13.t0 === "client_secret_basic" ? 11 : _context13.t0 === "client_secret_post" ? 16 : 19;
              break;
            case 11:
              if (client_secret) {
                _context13.next = 14;
                break;
              }
              logger2["throw"](new Error("A client_secret is required"));
              throw null;
            case 14:
              basicAuth = CryptoUtils.generateBasicAuth(client_id, client_secret);
              return _context13.abrupt("break", 19);
            case 16:
              params.append("client_id", client_id);
              if (client_secret) {
                params.append("client_secret", client_secret);
              }
              return _context13.abrupt("break", 19);
            case 19:
              _context13.next = 21;
              return this._metadataService.getTokenEndpoint(false);
            case 21:
              url = _context13.sent;
              logger2.debug("got token endpoint");
              _context13.next = 25;
              return this._jsonService.postForm(url, {
                body: params,
                basicAuth: basicAuth,
                initCredentials: this._settings.fetchRequestCredentials
              });
            case 25:
              response = _context13.sent;
              logger2.debug("got response");
              return _context13.abrupt("return", response);
            case 28:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function exchangeCode(_x13) {
        return _exchangeCode.apply(this, arguments);
      }
      return exchangeCode;
    }()
  }, {
    key: "exchangeCredentials",
    value: function () {
      var _exchangeCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref12) {
        var _ref12$grant_type, grant_type, _ref12$client_id, client_id, _ref12$client_secret, client_secret, _ref12$scope, scope, args, logger2, params, _i3, _Object$entries2, _Object$entries2$_i, key, value, basicAuth, url, response;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _ref12$grant_type = _ref12.grant_type, grant_type = _ref12$grant_type === void 0 ? "password" : _ref12$grant_type, _ref12$client_id = _ref12.client_id, client_id = _ref12$client_id === void 0 ? this._settings.client_id : _ref12$client_id, _ref12$client_secret = _ref12.client_secret, client_secret = _ref12$client_secret === void 0 ? this._settings.client_secret : _ref12$client_secret, _ref12$scope = _ref12.scope, scope = _ref12$scope === void 0 ? this._settings.scope : _ref12$scope, args = _objectWithoutProperties(_ref12, _excluded3);
              logger2 = this._logger.create("exchangeCredentials");
              if (!client_id) {
                logger2["throw"](new Error("A client_id is required"));
              }
              params = new URLSearchParams({
                grant_type: grant_type,
                scope: scope
              });
              for (_i3 = 0, _Object$entries2 = Object.entries(args); _i3 < _Object$entries2.length; _i3++) {
                _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2), key = _Object$entries2$_i[0], value = _Object$entries2$_i[1];
                if (value != null) {
                  params.set(key, value);
                }
              }
              _context14.t0 = this._settings.client_authentication;
              _context14.next = _context14.t0 === "client_secret_basic" ? 8 : _context14.t0 === "client_secret_post" ? 13 : 16;
              break;
            case 8:
              if (client_secret) {
                _context14.next = 11;
                break;
              }
              logger2["throw"](new Error("A client_secret is required"));
              throw null;
            case 11:
              basicAuth = CryptoUtils.generateBasicAuth(client_id, client_secret);
              return _context14.abrupt("break", 16);
            case 13:
              params.append("client_id", client_id);
              if (client_secret) {
                params.append("client_secret", client_secret);
              }
              return _context14.abrupt("break", 16);
            case 16:
              _context14.next = 18;
              return this._metadataService.getTokenEndpoint(false);
            case 18:
              url = _context14.sent;
              logger2.debug("got token endpoint");
              _context14.next = 22;
              return this._jsonService.postForm(url, {
                body: params,
                basicAuth: basicAuth,
                initCredentials: this._settings.fetchRequestCredentials
              });
            case 22:
              response = _context14.sent;
              logger2.debug("got response");
              return _context14.abrupt("return", response);
            case 25:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function exchangeCredentials(_x14) {
        return _exchangeCredentials.apply(this, arguments);
      }
      return exchangeCredentials;
    }()
  }, {
    key: "exchangeRefreshToken",
    value: function () {
      var _exchangeRefreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref13) {
        var _ref13$grant_type, grant_type, _ref13$client_id, client_id, _ref13$client_secret, client_secret, timeoutInSeconds, args, logger2, params, _i4, _Object$entries3, _Object$entries3$_i, key, value, basicAuth, url, response;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _ref13$grant_type = _ref13.grant_type, grant_type = _ref13$grant_type === void 0 ? "refresh_token" : _ref13$grant_type, _ref13$client_id = _ref13.client_id, client_id = _ref13$client_id === void 0 ? this._settings.client_id : _ref13$client_id, _ref13$client_secret = _ref13.client_secret, client_secret = _ref13$client_secret === void 0 ? this._settings.client_secret : _ref13$client_secret, timeoutInSeconds = _ref13.timeoutInSeconds, args = _objectWithoutProperties(_ref13, _excluded4);
              logger2 = this._logger.create("exchangeRefreshToken");
              if (!client_id) {
                logger2["throw"](new Error("A client_id is required"));
              }
              if (!args.refresh_token) {
                logger2["throw"](new Error("A refresh_token is required"));
              }
              params = new URLSearchParams({
                grant_type: grant_type
              });
              for (_i4 = 0, _Object$entries3 = Object.entries(args); _i4 < _Object$entries3.length; _i4++) {
                _Object$entries3$_i = _slicedToArray(_Object$entries3[_i4], 2), key = _Object$entries3$_i[0], value = _Object$entries3$_i[1];
                if (value != null) {
                  params.set(key, value);
                }
              }
              _context15.t0 = this._settings.client_authentication;
              _context15.next = _context15.t0 === "client_secret_basic" ? 9 : _context15.t0 === "client_secret_post" ? 14 : 17;
              break;
            case 9:
              if (client_secret) {
                _context15.next = 12;
                break;
              }
              logger2["throw"](new Error("A client_secret is required"));
              throw null;
            case 12:
              basicAuth = CryptoUtils.generateBasicAuth(client_id, client_secret);
              return _context15.abrupt("break", 17);
            case 14:
              params.append("client_id", client_id);
              if (client_secret) {
                params.append("client_secret", client_secret);
              }
              return _context15.abrupt("break", 17);
            case 17:
              _context15.next = 19;
              return this._metadataService.getTokenEndpoint(false);
            case 19:
              url = _context15.sent;
              logger2.debug("got token endpoint");
              _context15.next = 23;
              return this._jsonService.postForm(url, {
                body: params,
                basicAuth: basicAuth,
                timeoutInSeconds: timeoutInSeconds,
                initCredentials: this._settings.fetchRequestCredentials
              });
            case 23:
              response = _context15.sent;
              logger2.debug("got response");
              return _context15.abrupt("return", response);
            case 26:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function exchangeRefreshToken(_x15) {
        return _exchangeRefreshToken.apply(this, arguments);
      }
      return exchangeRefreshToken;
    }()
    /**
     * Revoke an access or refresh token.
     *
     * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
     */
  }, {
    key: "revoke",
    value: function () {
      var _revoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(args) {
        var _a, logger2, url, params, _i5, _Object$entries4, _Object$entries4$_i, key, value;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              logger2 = this._logger.create("revoke");
              if (!args.token) {
                logger2["throw"](new Error("A token is required"));
              }
              _context16.next = 4;
              return this._metadataService.getRevocationEndpoint(false);
            case 4:
              url = _context16.sent;
              logger2.debug("got revocation endpoint, revoking ".concat((_a = args.token_type_hint) != null ? _a : "default token type"));
              params = new URLSearchParams();
              for (_i5 = 0, _Object$entries4 = Object.entries(args); _i5 < _Object$entries4.length; _i5++) {
                _Object$entries4$_i = _slicedToArray(_Object$entries4[_i5], 2), key = _Object$entries4$_i[0], value = _Object$entries4$_i[1];
                if (value != null) {
                  params.set(key, value);
                }
              }
              params.set("client_id", this._settings.client_id);
              if (this._settings.client_secret) {
                params.set("client_secret", this._settings.client_secret);
              }
              _context16.next = 12;
              return this._jsonService.postForm(url, {
                body: params
              });
            case 12:
              logger2.debug("got response");
            case 13:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function revoke(_x16) {
        return _revoke.apply(this, arguments);
      }
      return revoke;
    }()
  }]);
  return TokenClient;
}();

// src/ResponseValidator.ts
var DefaultProtocolClaims = ["nbf", "jti", "auth_time", "nonce", "acr", "amr", "azp", "at_hash"
// https://openid.net/specs/openid-connect-core-1_0.html#CodeIDToken
];

var InternalRequiredProtocolClaims = ["sub", "iss", "aud", "exp", "iat"];
var ResponseValidator = /*#__PURE__*/function () {
  function ResponseValidator(_settings, _metadataService) {
    _classCallCheck(this, ResponseValidator);
    this._settings = _settings;
    this._metadataService = _metadataService;
    this._logger = new _Logger("ResponseValidator");
    this._userInfoService = new UserInfoService(this._settings, this._metadataService);
    this._tokenClient = new TokenClient(this._settings, this._metadataService);
  }
  _createClass(ResponseValidator, [{
    key: "validateSigninResponse",
    value: function () {
      var _validateSigninResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(response, state) {
        var logger2;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              logger2 = this._logger.create("validateSigninResponse");
              this._processSigninState(response, state);
              logger2.debug("state processed");
              _context17.next = 5;
              return this._processCode(response, state);
            case 5:
              logger2.debug("code processed");
              if (response.isOpenId) {
                this._validateIdTokenAttributes(response);
              }
              logger2.debug("tokens validated");
              _context17.next = 10;
              return this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
            case 10:
              logger2.debug("claims processed");
            case 11:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function validateSigninResponse(_x17, _x18) {
        return _validateSigninResponse.apply(this, arguments);
      }
      return validateSigninResponse;
    }()
  }, {
    key: "validateCredentialsResponse",
    value: function () {
      var _validateCredentialsResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(response, skipUserInfo) {
        var logger2;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              logger2 = this._logger.create("validateCredentialsResponse");
              if (response.isOpenId) {
                this._validateIdTokenAttributes(response);
              }
              logger2.debug("tokens validated");
              _context18.next = 5;
              return this._processClaims(response, skipUserInfo, response.isOpenId);
            case 5:
              logger2.debug("claims processed");
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function validateCredentialsResponse(_x19, _x20) {
        return _validateCredentialsResponse.apply(this, arguments);
      }
      return validateCredentialsResponse;
    }()
  }, {
    key: "validateRefreshResponse",
    value: function () {
      var _validateRefreshResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(response, state) {
        var _a, _b, logger2, hasIdToken;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              logger2 = this._logger.create("validateRefreshResponse");
              response.userState = state.data;
              (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
              (_b = response.scope) != null ? _b : response.scope = state.scope;
              if (response.isOpenId && !!response.id_token) {
                this._validateIdTokenAttributes(response, state.id_token);
                logger2.debug("ID Token validated");
              }
              if (!response.id_token) {
                response.id_token = state.id_token;
                response.profile = state.profile;
              }
              hasIdToken = response.isOpenId && !!response.id_token;
              _context19.next = 9;
              return this._processClaims(response, false, hasIdToken);
            case 9:
              logger2.debug("claims processed");
            case 10:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function validateRefreshResponse(_x21, _x22) {
        return _validateRefreshResponse.apply(this, arguments);
      }
      return validateRefreshResponse;
    }()
  }, {
    key: "validateSignoutResponse",
    value: function validateSignoutResponse(response, state) {
      var logger2 = this._logger.create("validateSignoutResponse");
      if (state.id !== response.state) {
        logger2["throw"](new Error("State does not match"));
      }
      logger2.debug("state validated");
      response.userState = state.data;
      if (response.error) {
        logger2.warn("Response was error", response.error);
        throw new _ErrorResponse(response);
      }
    }
  }, {
    key: "_processSigninState",
    value: function _processSigninState(response, state) {
      var _a;
      var logger2 = this._logger.create("_processSigninState");
      if (state.id !== response.state) {
        logger2["throw"](new Error("State does not match"));
      }
      if (!state.client_id) {
        logger2["throw"](new Error("No client_id on state"));
      }
      if (!state.authority) {
        logger2["throw"](new Error("No authority on state"));
      }
      if (this._settings.authority !== state.authority) {
        logger2["throw"](new Error("authority mismatch on settings vs. signin state"));
      }
      if (this._settings.client_id && this._settings.client_id !== state.client_id) {
        logger2["throw"](new Error("client_id mismatch on settings vs. signin state"));
      }
      logger2.debug("state validated");
      response.userState = state.data;
      (_a = response.scope) != null ? _a : response.scope = state.scope;
      if (response.error) {
        logger2.warn("Response was error", response.error);
        throw new _ErrorResponse(response);
      }
      if (state.code_verifier && !response.code) {
        logger2["throw"](new Error("Expected code in response"));
      }
      if (!state.code_verifier && response.code) {
        logger2["throw"](new Error("Unexpected code in response"));
      }
    }
  }, {
    key: "_processClaims",
    value: function () {
      var _processClaims2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(response) {
        var skipUserInfo,
          validateSub,
          logger2,
          claims,
          _args20 = arguments;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              skipUserInfo = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : false;
              validateSub = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : true;
              logger2 = this._logger.create("_processClaims");
              response.profile = this._filterProtocolClaims(response.profile);
              if (!(skipUserInfo || !this._settings.loadUserInfo || !response.access_token)) {
                _context20.next = 7;
                break;
              }
              logger2.debug("not loading user info");
              return _context20.abrupt("return");
            case 7:
              logger2.debug("loading user info");
              _context20.next = 10;
              return this._userInfoService.getClaims(response.access_token);
            case 10:
              claims = _context20.sent;
              logger2.debug("user info claims received from user info endpoint");
              if (validateSub && claims.sub !== response.profile.sub) {
                logger2["throw"](new Error("subject from UserInfo response does not match subject in ID Token"));
              }
              response.profile = this._mergeClaims(response.profile, this._filterProtocolClaims(claims));
              logger2.debug("user info claims received, updated profile:", response.profile);
            case 15:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function _processClaims(_x23) {
        return _processClaims2.apply(this, arguments);
      }
      return _processClaims;
    }()
  }, {
    key: "_mergeClaims",
    value: function _mergeClaims(claims1, claims2) {
      var result = _objectSpread({}, claims1);
      for (var _i6 = 0, _Object$entries5 = Object.entries(claims2); _i6 < _Object$entries5.length; _i6++) {
        var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i6], 2),
          claim = _Object$entries5$_i[0],
          values = _Object$entries5$_i[1];
        var _iterator3 = _createForOfIteratorHelper(Array.isArray(values) ? values : [values]),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var value = _step3.value;
            var previousValue = result[claim];
            if (!previousValue) {
              result[claim] = value;
            } else if (Array.isArray(previousValue)) {
              if (!previousValue.includes(value)) {
                previousValue.push(value);
              }
            } else if (result[claim] !== value) {
              if (_typeof(value) === "object" && this._settings.mergeClaims) {
                result[claim] = this._mergeClaims(previousValue, value);
              } else {
                result[claim] = [previousValue, value];
              }
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return result;
    }
  }, {
    key: "_filterProtocolClaims",
    value: function _filterProtocolClaims(claims) {
      var result = _objectSpread({}, claims);
      if (this._settings.filterProtocolClaims) {
        var protocolClaims;
        if (Array.isArray(this._settings.filterProtocolClaims)) {
          protocolClaims = this._settings.filterProtocolClaims;
        } else {
          protocolClaims = DefaultProtocolClaims;
        }
        var _iterator4 = _createForOfIteratorHelper(protocolClaims),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var claim = _step4.value;
            if (!InternalRequiredProtocolClaims.includes(claim)) {
              delete result[claim];
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
      return result;
    }
  }, {
    key: "_processCode",
    value: function () {
      var _processCode2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(response, state) {
        var logger2, tokenResponse;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              logger2 = this._logger.create("_processCode");
              if (!response.code) {
                _context21.next = 9;
                break;
              }
              logger2.debug("Validating code");
              _context21.next = 5;
              return this._tokenClient.exchangeCode(_objectSpread({
                client_id: state.client_id,
                client_secret: state.client_secret,
                code: response.code,
                redirect_uri: state.redirect_uri,
                code_verifier: state.code_verifier
              }, state.extraTokenParams));
            case 5:
              tokenResponse = _context21.sent;
              Object.assign(response, tokenResponse);
              _context21.next = 10;
              break;
            case 9:
              logger2.debug("No code to process");
            case 10:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function _processCode(_x24, _x25) {
        return _processCode2.apply(this, arguments);
      }
      return _processCode;
    }()
  }, {
    key: "_validateIdTokenAttributes",
    value: function _validateIdTokenAttributes(response, currentToken) {
      var _a;
      var logger2 = this._logger.create("_validateIdTokenAttributes");
      logger2.debug("decoding ID Token JWT");
      var profile = JwtUtils.decode((_a = response.id_token) != null ? _a : "");
      if (!profile.sub) {
        logger2["throw"](new Error("ID Token is missing a subject claim"));
      }
      if (currentToken) {
        var current = JwtUtils.decode(currentToken);
        if (current.sub !== profile.sub) {
          logger2["throw"](new Error("sub in id_token does not match current sub"));
        }
        if (current.auth_time && current.auth_time !== profile.auth_time) {
          logger2["throw"](new Error("auth_time in id_token does not match original auth_time"));
        }
        if (current.azp && current.azp !== profile.azp) {
          logger2["throw"](new Error("azp in id_token does not match original azp"));
        }
        if (!current.azp && profile.azp) {
          logger2["throw"](new Error("azp not in id_token, but present in original id_token"));
        }
      }
      response.profile = profile;
    }
  }]);
  return ResponseValidator;
}();

// src/State.ts
var _State = /*#__PURE__*/function () {
  function _State(args) {
    _classCallCheck(this, _State);
    this.id = args.id || CryptoUtils.generateUUIDv4();
    this.data = args.data;
    if (args.created && args.created > 0) {
      this.created = args.created;
    } else {
      this.created = Timer.getEpochTime();
    }
    this.request_type = args.request_type;
  }
  _createClass(_State, [{
    key: "toStorageString",
    value: function toStorageString() {
      new _Logger("State").create("toStorageString");
      return JSON.stringify({
        id: this.id,
        data: this.data,
        created: this.created,
        request_type: this.request_type
      });
    }
  }], [{
    key: "fromStorageString",
    value: function fromStorageString(storageString) {
      _Logger.createStatic("State", "fromStorageString");
      return new _State(JSON.parse(storageString));
    }
  }, {
    key: "clearStaleState",
    value: function () {
      var _clearStaleState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(storage, age) {
        var logger2, cutoff, keys, i, key, item, remove, state;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              logger2 = _Logger.createStatic("State", "clearStaleState");
              cutoff = Timer.getEpochTime() - age;
              _context22.next = 4;
              return storage.getAllKeys();
            case 4:
              keys = _context22.sent;
              logger2.debug("got keys", keys);
              i = 0;
            case 7:
              if (!(i < keys.length)) {
                _context22.next = 18;
                break;
              }
              key = keys[i];
              _context22.next = 11;
              return storage.get(key);
            case 11:
              item = _context22.sent;
              remove = false;
              if (item) {
                try {
                  state = _State.fromStorageString(item);
                  logger2.debug("got item from key:", key, state.created);
                  if (state.created <= cutoff) {
                    remove = true;
                  }
                } catch (err) {
                  logger2.error("Error parsing state for key:", key, err);
                  remove = true;
                }
              } else {
                logger2.debug("no item in storage for key:", key);
                remove = true;
              }
              if (remove) {
                logger2.debug("removed item for key:", key);
                void storage.remove(key);
              }
            case 15:
              i++;
              _context22.next = 7;
              break;
            case 18:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      function clearStaleState(_x26, _x27) {
        return _clearStaleState.apply(this, arguments);
      }
      return clearStaleState;
    }()
  }]);
  return _State;
}();

// src/SigninState.ts
var _SigninState = /*#__PURE__*/function (_State2) {
  _inherits(_SigninState, _State2);
  var _super4 = _createSuper(_SigninState);
  function _SigninState(args) {
    var _this9;
    _classCallCheck(this, _SigninState);
    _this9 = _super4.call(this, args);
    if (args.code_verifier === true) {
      _this9.code_verifier = CryptoUtils.generateCodeVerifier();
    } else if (args.code_verifier) {
      _this9.code_verifier = args.code_verifier;
    }
    if (_this9.code_verifier) {
      _this9.code_challenge = CryptoUtils.generateCodeChallenge(_this9.code_verifier);
    }
    _this9.authority = args.authority;
    _this9.client_id = args.client_id;
    _this9.redirect_uri = args.redirect_uri;
    _this9.scope = args.scope;
    _this9.client_secret = args.client_secret;
    _this9.extraTokenParams = args.extraTokenParams;
    _this9.response_mode = args.response_mode;
    _this9.skipUserInfo = args.skipUserInfo;
    return _this9;
  }
  _createClass(_SigninState, [{
    key: "toStorageString",
    value: function toStorageString() {
      new _Logger("SigninState").create("toStorageString");
      return JSON.stringify({
        id: this.id,
        data: this.data,
        created: this.created,
        request_type: this.request_type,
        code_verifier: this.code_verifier,
        authority: this.authority,
        client_id: this.client_id,
        redirect_uri: this.redirect_uri,
        scope: this.scope,
        client_secret: this.client_secret,
        extraTokenParams: this.extraTokenParams,
        response_mode: this.response_mode,
        skipUserInfo: this.skipUserInfo
      });
    }
  }], [{
    key: "fromStorageString",
    value: function fromStorageString(storageString) {
      _Logger.createStatic("SigninState", "fromStorageString");
      var data = JSON.parse(storageString);
      return new _SigninState(data);
    }
  }]);
  return _SigninState;
}(_State);

// src/SigninRequest.ts
var SigninRequest = /*#__PURE__*/_createClass(function SigninRequest(_ref14) {
  var url = _ref14.url,
    authority = _ref14.authority,
    client_id = _ref14.client_id,
    redirect_uri = _ref14.redirect_uri,
    response_type = _ref14.response_type,
    scope = _ref14.scope,
    state_data = _ref14.state_data,
    response_mode = _ref14.response_mode,
    request_type = _ref14.request_type,
    client_secret = _ref14.client_secret,
    nonce = _ref14.nonce,
    resource = _ref14.resource,
    skipUserInfo = _ref14.skipUserInfo,
    extraQueryParams = _ref14.extraQueryParams,
    extraTokenParams = _ref14.extraTokenParams,
    optionalParams = _objectWithoutProperties(_ref14, _excluded5);
  _classCallCheck(this, SigninRequest);
  this._logger = new _Logger("SigninRequest");
  if (!url) {
    this._logger.error("ctor: No url passed");
    throw new Error("url");
  }
  if (!client_id) {
    this._logger.error("ctor: No client_id passed");
    throw new Error("client_id");
  }
  if (!redirect_uri) {
    this._logger.error("ctor: No redirect_uri passed");
    throw new Error("redirect_uri");
  }
  if (!response_type) {
    this._logger.error("ctor: No response_type passed");
    throw new Error("response_type");
  }
  if (!scope) {
    this._logger.error("ctor: No scope passed");
    throw new Error("scope");
  }
  if (!authority) {
    this._logger.error("ctor: No authority passed");
    throw new Error("authority");
  }
  this.state = new _SigninState({
    data: state_data,
    request_type: request_type,
    code_verifier: true,
    client_id: client_id,
    authority: authority,
    redirect_uri: redirect_uri,
    response_mode: response_mode,
    client_secret: client_secret,
    scope: scope,
    extraTokenParams: extraTokenParams,
    skipUserInfo: skipUserInfo
  });
  var parsedUrl = new URL(url);
  parsedUrl.searchParams.append("client_id", client_id);
  parsedUrl.searchParams.append("redirect_uri", redirect_uri);
  parsedUrl.searchParams.append("response_type", response_type);
  parsedUrl.searchParams.append("scope", scope);
  if (nonce) {
    parsedUrl.searchParams.append("nonce", nonce);
  }
  parsedUrl.searchParams.append("state", this.state.id);
  if (this.state.code_challenge) {
    parsedUrl.searchParams.append("code_challenge", this.state.code_challenge);
    parsedUrl.searchParams.append("code_challenge_method", "S256");
  }
  if (resource) {
    var resources = Array.isArray(resource) ? resource : [resource];
    resources.forEach(function (r) {
      return parsedUrl.searchParams.append("resource", r);
    });
  }
  for (var _i7 = 0, _Object$entries6 = Object.entries(_objectSpread(_objectSpread({
      response_mode: response_mode
    }, optionalParams), extraQueryParams)); _i7 < _Object$entries6.length; _i7++) {
    var _Object$entries6$_i = _slicedToArray(_Object$entries6[_i7], 2),
      key = _Object$entries6$_i[0],
      value = _Object$entries6$_i[1];
    if (value != null) {
      parsedUrl.searchParams.append(key, value.toString());
    }
  }
  this.url = parsedUrl.href;
});

// src/SigninResponse.ts
var OidcScope = "openid";
var _SigninResponse = /*#__PURE__*/function () {
  function _SigninResponse(params) {
    _classCallCheck(this, _SigninResponse);
    /** @see {@link User.access_token} */
    this.access_token = "";
    /** @see {@link User.token_type} */
    this.token_type = "";
    /** @see {@link User.profile} */
    this.profile = {};
    this.state = params.get("state");
    this.session_state = params.get("session_state");
    this.error = params.get("error");
    this.error_description = params.get("error_description");
    this.error_uri = params.get("error_uri");
    this.code = params.get("code");
  }
  _createClass(_SigninResponse, [{
    key: "expires_in",
    get: function get() {
      if (this.expires_at === void 0) {
        return void 0;
      }
      return this.expires_at - Timer.getEpochTime();
    },
    set: function set(value) {
      if (typeof value === "string") value = Number(value);
      if (value !== void 0 && value >= 0) {
        this.expires_at = Math.floor(value) + Timer.getEpochTime();
      }
    }
  }, {
    key: "isOpenId",
    get: function get() {
      var _a;
      return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes(OidcScope)) || !!this.id_token;
    }
  }]);
  return _SigninResponse;
}();

// src/SignoutRequest.ts
var SignoutRequest = /*#__PURE__*/_createClass(function SignoutRequest(_ref15) {
  var url = _ref15.url,
    state_data = _ref15.state_data,
    id_token_hint = _ref15.id_token_hint,
    post_logout_redirect_uri = _ref15.post_logout_redirect_uri,
    extraQueryParams = _ref15.extraQueryParams,
    request_type = _ref15.request_type;
  _classCallCheck(this, SignoutRequest);
  this._logger = new _Logger("SignoutRequest");
  if (!url) {
    this._logger.error("ctor: No url passed");
    throw new Error("url");
  }
  var parsedUrl = new URL(url);
  if (id_token_hint) {
    parsedUrl.searchParams.append("id_token_hint", id_token_hint);
  }
  if (post_logout_redirect_uri) {
    parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
    if (state_data) {
      this.state = new _State({
        data: state_data,
        request_type: request_type
      });
      parsedUrl.searchParams.append("state", this.state.id);
    }
  }
  for (var _i8 = 0, _Object$entries7 = Object.entries(_objectSpread({}, extraQueryParams)); _i8 < _Object$entries7.length; _i8++) {
    var _Object$entries7$_i = _slicedToArray(_Object$entries7[_i8], 2),
      key = _Object$entries7$_i[0],
      value = _Object$entries7$_i[1];
    if (value != null) {
      parsedUrl.searchParams.append(key, value.toString());
    }
  }
  this.url = parsedUrl.href;
});

// src/SignoutResponse.ts
var _SignoutResponse = /*#__PURE__*/_createClass(function _SignoutResponse(params) {
  _classCallCheck(this, _SignoutResponse);
  this.state = params.get("state");
  this.error = params.get("error");
  this.error_description = params.get("error_description");
  this.error_uri = params.get("error_uri");
});

// src/OidcClient.ts
var _OidcClient = /*#__PURE__*/function () {
  function _OidcClient(settings) {
    _classCallCheck(this, _OidcClient);
    this._logger = new _Logger("OidcClient");
    this.settings = new _OidcClientSettingsStore(settings);
    this.metadataService = new _MetadataService(this.settings);
    this._validator = new ResponseValidator(this.settings, this.metadataService);
    this._tokenClient = new TokenClient(this.settings, this.metadataService);
  }
  _createClass(_OidcClient, [{
    key: "createSigninRequest",
    value: function () {
      var _createSigninRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(_ref16) {
        var state, request, request_uri, request_type, id_token_hint, login_hint, skipUserInfo, nonce, _ref16$response_type, response_type, _ref16$scope, scope, _ref16$redirect_uri, redirect_uri, _ref16$prompt, prompt, _ref16$display, display, _ref16$max_age, max_age, _ref16$ui_locales, ui_locales, _ref16$acr_values, acr_values, _ref16$resource, resource, _ref16$response_mode, response_mode, _ref16$extraQueryPara, extraQueryParams, _ref16$extraTokenPara, extraTokenParams, logger2, url, signinRequest, signinState;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              state = _ref16.state, request = _ref16.request, request_uri = _ref16.request_uri, request_type = _ref16.request_type, id_token_hint = _ref16.id_token_hint, login_hint = _ref16.login_hint, skipUserInfo = _ref16.skipUserInfo, nonce = _ref16.nonce, _ref16$response_type = _ref16.response_type, response_type = _ref16$response_type === void 0 ? this.settings.response_type : _ref16$response_type, _ref16$scope = _ref16.scope, scope = _ref16$scope === void 0 ? this.settings.scope : _ref16$scope, _ref16$redirect_uri = _ref16.redirect_uri, redirect_uri = _ref16$redirect_uri === void 0 ? this.settings.redirect_uri : _ref16$redirect_uri, _ref16$prompt = _ref16.prompt, prompt = _ref16$prompt === void 0 ? this.settings.prompt : _ref16$prompt, _ref16$display = _ref16.display, display = _ref16$display === void 0 ? this.settings.display : _ref16$display, _ref16$max_age = _ref16.max_age, max_age = _ref16$max_age === void 0 ? this.settings.max_age : _ref16$max_age, _ref16$ui_locales = _ref16.ui_locales, ui_locales = _ref16$ui_locales === void 0 ? this.settings.ui_locales : _ref16$ui_locales, _ref16$acr_values = _ref16.acr_values, acr_values = _ref16$acr_values === void 0 ? this.settings.acr_values : _ref16$acr_values, _ref16$resource = _ref16.resource, resource = _ref16$resource === void 0 ? this.settings.resource : _ref16$resource, _ref16$response_mode = _ref16.response_mode, response_mode = _ref16$response_mode === void 0 ? this.settings.response_mode : _ref16$response_mode, _ref16$extraQueryPara = _ref16.extraQueryParams, extraQueryParams = _ref16$extraQueryPara === void 0 ? this.settings.extraQueryParams : _ref16$extraQueryPara, _ref16$extraTokenPara = _ref16.extraTokenParams, extraTokenParams = _ref16$extraTokenPara === void 0 ? this.settings.extraTokenParams : _ref16$extraTokenPara;
              logger2 = this._logger.create("createSigninRequest");
              if (!(response_type !== "code")) {
                _context23.next = 4;
                break;
              }
              throw new Error("Only the Authorization Code flow (with PKCE) is supported");
            case 4:
              _context23.next = 6;
              return this.metadataService.getAuthorizationEndpoint();
            case 6:
              url = _context23.sent;
              logger2.debug("Received authorization endpoint", url);
              signinRequest = new SigninRequest({
                url: url,
                authority: this.settings.authority,
                client_id: this.settings.client_id,
                redirect_uri: redirect_uri,
                response_type: response_type,
                scope: scope,
                state_data: state,
                prompt: prompt,
                display: display,
                max_age: max_age,
                ui_locales: ui_locales,
                id_token_hint: id_token_hint,
                login_hint: login_hint,
                acr_values: acr_values,
                resource: resource,
                request: request,
                request_uri: request_uri,
                extraQueryParams: extraQueryParams,
                extraTokenParams: extraTokenParams,
                request_type: request_type,
                response_mode: response_mode,
                client_secret: this.settings.client_secret,
                skipUserInfo: skipUserInfo,
                nonce: nonce
              });
              _context23.next = 11;
              return this.clearStaleState();
            case 11:
              signinState = signinRequest.state;
              _context23.next = 14;
              return this.settings.stateStore.set(signinState.id, signinState.toStorageString());
            case 14:
              return _context23.abrupt("return", signinRequest);
            case 15:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function createSigninRequest(_x28) {
        return _createSigninRequest.apply(this, arguments);
      }
      return createSigninRequest;
    }()
  }, {
    key: "readSigninResponseState",
    value: function () {
      var _readSigninResponseState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(url) {
        var removeState,
          logger2,
          response,
          storedStateString,
          state,
          _args24 = arguments;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              removeState = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : false;
              logger2 = this._logger.create("readSigninResponseState");
              response = new _SigninResponse(UrlUtils.readParams(url, this.settings.response_mode));
              if (response.state) {
                _context24.next = 6;
                break;
              }
              logger2["throw"](new Error("No state in response"));
              throw null;
            case 6:
              _context24.next = 8;
              return this.settings.stateStore[removeState ? "remove" : "get"](response.state);
            case 8:
              storedStateString = _context24.sent;
              if (storedStateString) {
                _context24.next = 12;
                break;
              }
              logger2["throw"](new Error("No matching state found in storage"));
              throw null;
            case 12:
              state = _SigninState.fromStorageString(storedStateString);
              return _context24.abrupt("return", {
                state: state,
                response: response
              });
            case 14:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function readSigninResponseState(_x29) {
        return _readSigninResponseState.apply(this, arguments);
      }
      return readSigninResponseState;
    }()
  }, {
    key: "processSigninResponse",
    value: function () {
      var _processSigninResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(url) {
        var logger2, _yield$this$readSigni, state, response;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              logger2 = this._logger.create("processSigninResponse");
              _context25.next = 3;
              return this.readSigninResponseState(url, true);
            case 3:
              _yield$this$readSigni = _context25.sent;
              state = _yield$this$readSigni.state;
              response = _yield$this$readSigni.response;
              logger2.debug("received state from storage; validating response");
              _context25.next = 9;
              return this._validator.validateSigninResponse(response, state);
            case 9:
              return _context25.abrupt("return", response);
            case 10:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function processSigninResponse(_x30) {
        return _processSigninResponse.apply(this, arguments);
      }
      return processSigninResponse;
    }()
  }, {
    key: "processResourceOwnerPasswordCredentials",
    value: function () {
      var _processResourceOwnerPasswordCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(_ref17) {
        var username, password, _ref17$skipUserInfo, skipUserInfo, _ref17$extraTokenPara, extraTokenParams, tokenResponse, signinResponse;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              username = _ref17.username, password = _ref17.password, _ref17$skipUserInfo = _ref17.skipUserInfo, skipUserInfo = _ref17$skipUserInfo === void 0 ? false : _ref17$skipUserInfo, _ref17$extraTokenPara = _ref17.extraTokenParams, extraTokenParams = _ref17$extraTokenPara === void 0 ? {} : _ref17$extraTokenPara;
              _context26.next = 3;
              return this._tokenClient.exchangeCredentials(_objectSpread({
                username: username,
                password: password
              }, extraTokenParams));
            case 3:
              tokenResponse = _context26.sent;
              signinResponse = new _SigninResponse(new URLSearchParams());
              Object.assign(signinResponse, tokenResponse);
              _context26.next = 8;
              return this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
            case 8:
              return _context26.abrupt("return", signinResponse);
            case 9:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function processResourceOwnerPasswordCredentials(_x31) {
        return _processResourceOwnerPasswordCredentials.apply(this, arguments);
      }
      return processResourceOwnerPasswordCredentials;
    }()
  }, {
    key: "useRefreshToken",
    value: function () {
      var _useRefreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(_ref18) {
        var state, timeoutInSeconds, _a, logger2, scope, allowableScopes, providedScopes, result, response;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              state = _ref18.state, timeoutInSeconds = _ref18.timeoutInSeconds;
              logger2 = this._logger.create("useRefreshToken");
              if (this.settings.refreshTokenAllowedScope === void 0) {
                scope = state.scope;
              } else {
                allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
                providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
                scope = providedScopes.filter(function (s) {
                  return allowableScopes.includes(s);
                }).join(" ");
              }
              _context27.next = 5;
              return this._tokenClient.exchangeRefreshToken({
                refresh_token: state.refresh_token,
                // provide the (possible filtered) scope list
                scope: scope,
                timeoutInSeconds: timeoutInSeconds
              });
            case 5:
              result = _context27.sent;
              response = new _SigninResponse(new URLSearchParams());
              Object.assign(response, result);
              logger2.debug("validating response", response);
              _context27.next = 11;
              return this._validator.validateRefreshResponse(response, _objectSpread(_objectSpread({}, state), {}, {
                // overide the scope in the state handed over to the validator
                // so it can set the granted scope to the requested scope in case none is included in the response
                scope: scope
              }));
            case 11:
              return _context27.abrupt("return", response);
            case 12:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function useRefreshToken(_x32) {
        return _useRefreshToken.apply(this, arguments);
      }
      return useRefreshToken;
    }()
  }, {
    key: "createSignoutRequest",
    value: function () {
      var _createSignoutRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var _ref19,
          state,
          id_token_hint,
          request_type,
          _ref19$post_logout_re,
          post_logout_redirect_uri,
          _ref19$extraQueryPara,
          extraQueryParams,
          logger2,
          url,
          request,
          signoutState,
          _args28 = arguments;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _ref19 = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : {}, state = _ref19.state, id_token_hint = _ref19.id_token_hint, request_type = _ref19.request_type, _ref19$post_logout_re = _ref19.post_logout_redirect_uri, post_logout_redirect_uri = _ref19$post_logout_re === void 0 ? this.settings.post_logout_redirect_uri : _ref19$post_logout_re, _ref19$extraQueryPara = _ref19.extraQueryParams, extraQueryParams = _ref19$extraQueryPara === void 0 ? this.settings.extraQueryParams : _ref19$extraQueryPara;
              logger2 = this._logger.create("createSignoutRequest");
              _context28.next = 4;
              return this.metadataService.getEndSessionEndpoint();
            case 4:
              url = _context28.sent;
              if (url) {
                _context28.next = 8;
                break;
              }
              logger2["throw"](new Error("No end session endpoint"));
              throw null;
            case 8:
              logger2.debug("Received end session endpoint", url);
              request = new SignoutRequest({
                url: url,
                id_token_hint: id_token_hint,
                post_logout_redirect_uri: post_logout_redirect_uri,
                state_data: state,
                extraQueryParams: extraQueryParams,
                request_type: request_type
              });
              _context28.next = 12;
              return this.clearStaleState();
            case 12:
              signoutState = request.state;
              if (!signoutState) {
                _context28.next = 17;
                break;
              }
              logger2.debug("Signout request has state to persist");
              _context28.next = 17;
              return this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
            case 17:
              return _context28.abrupt("return", request);
            case 18:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function createSignoutRequest() {
        return _createSignoutRequest.apply(this, arguments);
      }
      return createSignoutRequest;
    }()
  }, {
    key: "readSignoutResponseState",
    value: function () {
      var _readSignoutResponseState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(url) {
        var removeState,
          logger2,
          response,
          storedStateString,
          state,
          _args29 = arguments;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              removeState = _args29.length > 1 && _args29[1] !== undefined ? _args29[1] : false;
              logger2 = this._logger.create("readSignoutResponseState");
              response = new _SignoutResponse(UrlUtils.readParams(url, this.settings.response_mode));
              if (response.state) {
                _context29.next = 9;
                break;
              }
              logger2.debug("No state in response");
              if (!response.error) {
                _context29.next = 8;
                break;
              }
              logger2.warn("Response was error:", response.error);
              throw new _ErrorResponse(response);
            case 8:
              return _context29.abrupt("return", {
                state: void 0,
                response: response
              });
            case 9:
              _context29.next = 11;
              return this.settings.stateStore[removeState ? "remove" : "get"](response.state);
            case 11:
              storedStateString = _context29.sent;
              if (storedStateString) {
                _context29.next = 15;
                break;
              }
              logger2["throw"](new Error("No matching state found in storage"));
              throw null;
            case 15:
              state = _State.fromStorageString(storedStateString);
              return _context29.abrupt("return", {
                state: state,
                response: response
              });
            case 17:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function readSignoutResponseState(_x33) {
        return _readSignoutResponseState.apply(this, arguments);
      }
      return readSignoutResponseState;
    }()
  }, {
    key: "processSignoutResponse",
    value: function () {
      var _processSignoutResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(url) {
        var logger2, _yield$this$readSigno, state, response;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              logger2 = this._logger.create("processSignoutResponse");
              _context30.next = 3;
              return this.readSignoutResponseState(url, true);
            case 3:
              _yield$this$readSigno = _context30.sent;
              state = _yield$this$readSigno.state;
              response = _yield$this$readSigno.response;
              if (state) {
                logger2.debug("Received state from storage; validating response");
                this._validator.validateSignoutResponse(response, state);
              } else {
                logger2.debug("No state from storage; skipping response validation");
              }
              return _context30.abrupt("return", response);
            case 8:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function processSignoutResponse(_x34) {
        return _processSignoutResponse.apply(this, arguments);
      }
      return processSignoutResponse;
    }()
  }, {
    key: "clearStaleState",
    value: function clearStaleState() {
      this._logger.create("clearStaleState");
      return _State.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
    }
  }, {
    key: "revokeToken",
    value: function () {
      var _revokeToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(token, type) {
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              this._logger.create("revokeToken");
              _context31.next = 3;
              return this._tokenClient.revoke({
                token: token,
                token_type_hint: type
              });
            case 3:
              return _context31.abrupt("return", _context31.sent);
            case 4:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function revokeToken(_x35, _x36) {
        return _revokeToken.apply(this, arguments);
      }
      return revokeToken;
    }()
  }]);
  return _OidcClient;
}();

// src/SessionMonitor.ts
var _SessionMonitor = /*#__PURE__*/function () {
  function _SessionMonitor(_userManager) {
    var _this10 = this;
    _classCallCheck(this, _SessionMonitor);
    this._userManager = _userManager;
    this._logger = new _Logger("SessionMonitor");
    this._start = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(user) {
        var session_state, logger2, url, client_id, intervalInSeconds, stopOnError, checkSessionIFrame;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              session_state = user.session_state;
              if (session_state) {
                _context32.next = 3;
                break;
              }
              return _context32.abrupt("return");
            case 3:
              logger2 = _this10._logger.create("_start");
              if (user.profile) {
                _this10._sub = user.profile.sub;
                _this10._sid = user.profile.sid;
                logger2.debug("session_state", session_state, ", sub", _this10._sub);
              } else {
                _this10._sub = void 0;
                _this10._sid = void 0;
                logger2.debug("session_state", session_state, ", anonymous user");
              }
              if (!_this10._checkSessionIFrame) {
                _context32.next = 8;
                break;
              }
              _this10._checkSessionIFrame.start(session_state);
              return _context32.abrupt("return");
            case 8:
              _context32.prev = 8;
              _context32.next = 11;
              return _this10._userManager.metadataService.getCheckSessionIframe();
            case 11:
              url = _context32.sent;
              if (!url) {
                _context32.next = 24;
                break;
              }
              logger2.debug("initializing check session iframe");
              client_id = _this10._userManager.settings.client_id;
              intervalInSeconds = _this10._userManager.settings.checkSessionIntervalInSeconds;
              stopOnError = _this10._userManager.settings.stopCheckSessionOnError;
              checkSessionIFrame = new _CheckSessionIFrame(_this10._callback, client_id, url, intervalInSeconds, stopOnError);
              _context32.next = 20;
              return checkSessionIFrame.load();
            case 20:
              _this10._checkSessionIFrame = checkSessionIFrame;
              checkSessionIFrame.start(session_state);
              _context32.next = 25;
              break;
            case 24:
              logger2.warn("no check session iframe found in the metadata");
            case 25:
              _context32.next = 30;
              break;
            case 27:
              _context32.prev = 27;
              _context32.t0 = _context32["catch"](8);
              logger2.error("Error from getCheckSessionIframe:", _context32.t0 instanceof Error ? _context32.t0.message : _context32.t0);
            case 30:
            case "end":
              return _context32.stop();
          }
        }, _callee32, null, [[8, 27]]);
      }));
      return function (_x37) {
        return _ref20.apply(this, arguments);
      };
    }();
    this._stop = function () {
      var logger2 = _this10._logger.create("_stop");
      _this10._sub = void 0;
      _this10._sid = void 0;
      if (_this10._checkSessionIFrame) {
        _this10._checkSessionIFrame.stop();
      }
      if (_this10._userManager.settings.monitorAnonymousSession) {
        var timerHandle = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
          var session, tmpUser;
          return _regeneratorRuntime().wrap(function _callee33$(_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                clearInterval(timerHandle);
                _context33.prev = 1;
                _context33.next = 4;
                return _this10._userManager.querySessionStatus();
              case 4:
                session = _context33.sent;
                if (session) {
                  tmpUser = {
                    session_state: session.session_state,
                    profile: session.sub && session.sid ? {
                      sub: session.sub,
                      sid: session.sid
                    } : null
                  };
                  void _this10._start(tmpUser);
                }
                _context33.next = 11;
                break;
              case 8:
                _context33.prev = 8;
                _context33.t0 = _context33["catch"](1);
                logger2.error("error from querySessionStatus", _context33.t0 instanceof Error ? _context33.t0.message : _context33.t0);
              case 11:
              case "end":
                return _context33.stop();
            }
          }, _callee33, null, [[1, 8]]);
        })), 1e3);
      }
    };
    this._callback = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
      var logger2, session, raiseEvent;
      return _regeneratorRuntime().wrap(function _callee34$(_context34) {
        while (1) switch (_context34.prev = _context34.next) {
          case 0:
            logger2 = _this10._logger.create("_callback");
            _context34.prev = 1;
            _context34.next = 4;
            return _this10._userManager.querySessionStatus();
          case 4:
            session = _context34.sent;
            raiseEvent = true;
            if (session && _this10._checkSessionIFrame) {
              if (session.sub === _this10._sub) {
                raiseEvent = false;
                _this10._checkSessionIFrame.start(session.session_state);
                if (session.sid === _this10._sid) {
                  logger2.debug("same sub still logged in at OP, restarting check session iframe; session_state", session.session_state);
                } else {
                  logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
                  _this10._userManager.events._raiseUserSessionChanged();
                }
              } else {
                logger2.debug("different subject signed into OP", session.sub);
              }
            } else {
              logger2.debug("subject no longer signed into OP");
            }
            if (raiseEvent) {
              if (_this10._sub) {
                _this10._userManager.events._raiseUserSignedOut();
              } else {
                _this10._userManager.events._raiseUserSignedIn();
              }
            } else {
              logger2.debug("no change in session detected, no event to raise");
            }
            _context34.next = 13;
            break;
          case 10:
            _context34.prev = 10;
            _context34.t0 = _context34["catch"](1);
            if (_this10._sub) {
              logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", _context34.t0);
              _this10._userManager.events._raiseUserSignedOut();
            }
          case 13:
          case "end":
            return _context34.stop();
        }
      }, _callee34, null, [[1, 10]]);
    }));
    if (!_userManager) {
      this._logger["throw"](new Error("No user manager passed"));
    }
    this._userManager.events.addUserLoaded(this._start);
    this._userManager.events.addUserUnloaded(this._stop);
    this._init()["catch"](function (err) {
      _this10._logger.error(err);
    });
  }
  _createClass(_SessionMonitor, [{
    key: "_init",
    value: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var user, session, tmpUser;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              this._logger.create("_init");
              _context35.next = 3;
              return this._userManager.getUser();
            case 3:
              user = _context35.sent;
              if (!user) {
                _context35.next = 8;
                break;
              }
              void this._start(user);
              _context35.next = 13;
              break;
            case 8:
              if (!this._userManager.settings.monitorAnonymousSession) {
                _context35.next = 13;
                break;
              }
              _context35.next = 11;
              return this._userManager.querySessionStatus();
            case 11:
              session = _context35.sent;
              if (session) {
                tmpUser = {
                  session_state: session.session_state,
                  profile: session.sub && session.sid ? {
                    sub: session.sub,
                    sid: session.sid
                  } : null
                };
                void this._start(tmpUser);
              }
            case 13:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function _init() {
        return _init2.apply(this, arguments);
      }
      return _init;
    }()
  }]);
  return _SessionMonitor;
}();

// src/User.ts
var _User = /*#__PURE__*/function () {
  function _User(args) {
    _classCallCheck(this, _User);
    var _a;
    this.id_token = args.id_token;
    this.session_state = (_a = args.session_state) != null ? _a : null;
    this.access_token = args.access_token;
    this.refresh_token = args.refresh_token;
    this.token_type = args.token_type;
    this.scope = args.scope;
    this.profile = args.profile;
    this.expires_at = args.expires_at;
    this.state = args.userState;
  }
  /** Computed number of seconds the access token has remaining. */
  _createClass(_User, [{
    key: "expires_in",
    get: function get() {
      if (this.expires_at === void 0) {
        return void 0;
      }
      return this.expires_at - Timer.getEpochTime();
    },
    set: function set(value) {
      if (value !== void 0) {
        this.expires_at = Math.floor(value) + Timer.getEpochTime();
      }
    }
    /** Computed value indicating if the access token is expired. */
  }, {
    key: "expired",
    get: function get() {
      var expires_in = this.expires_in;
      if (expires_in === void 0) {
        return void 0;
      }
      return expires_in <= 0;
    }
    /** Array representing the parsed values from the `scope`. */
  }, {
    key: "scopes",
    get: function get() {
      var _a, _b;
      return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
    }
  }, {
    key: "toStorageString",
    value: function toStorageString() {
      new _Logger("User").create("toStorageString");
      return JSON.stringify({
        id_token: this.id_token,
        session_state: this.session_state,
        access_token: this.access_token,
        refresh_token: this.refresh_token,
        token_type: this.token_type,
        scope: this.scope,
        profile: this.profile,
        expires_at: this.expires_at
      });
    }
  }], [{
    key: "fromStorageString",
    value: function fromStorageString(storageString) {
      _Logger.createStatic("User", "fromStorageString");
      return new _User(JSON.parse(storageString));
    }
  }]);
  return _User;
}();

// src/navigators/AbstractChildWindow.ts
var messageSource = "oidc-client";
var AbstractChildWindow = /*#__PURE__*/function () {
  function AbstractChildWindow() {
    _classCallCheck(this, AbstractChildWindow);
    this._abort = new Event("Window navigation aborted");
    this._disposeHandlers = /* @__PURE__ */new Set();
    this._window = null;
  }
  _createClass(AbstractChildWindow, [{
    key: "navigate",
    value: function () {
      var _navigate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(params) {
        var _this11 = this;
        var logger2, _yield$Promise, url, keepOpen;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              logger2 = this._logger.create("navigate");
              if (this._window) {
                _context36.next = 3;
                break;
              }
              throw new Error("Attempted to navigate on a disposed window");
            case 3:
              logger2.debug("setting URL in window");
              this._window.location.replace(params.url);
              _context36.next = 7;
              return new Promise(function (resolve, reject) {
                var listener = function listener(e) {
                  var _a;
                  var data = e.data;
                  var origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
                  if (e.origin !== origin || (data == null ? void 0 : data.source) !== messageSource) {
                    return;
                  }
                  try {
                    var state = UrlUtils.readParams(data.url, params.response_mode).get("state");
                    if (!state) {
                      logger2.warn("no state found in response url");
                    }
                    if (e.source !== _this11._window && state !== params.state) {
                      return;
                    }
                  } catch (err) {
                    _this11._dispose();
                    reject(new Error("Invalid response from window"));
                  }
                  resolve(data);
                };
                window.addEventListener("message", listener, false);
                _this11._disposeHandlers.add(function () {
                  return window.removeEventListener("message", listener, false);
                });
                _this11._disposeHandlers.add(_this11._abort.addHandler(function (reason) {
                  _this11._dispose();
                  reject(reason);
                }));
              });
            case 7:
              _yield$Promise = _context36.sent;
              url = _yield$Promise.url;
              keepOpen = _yield$Promise.keepOpen;
              logger2.debug("got response from window");
              this._dispose();
              if (!keepOpen) {
                this.close();
              }
              return _context36.abrupt("return", {
                url: url
              });
            case 14:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function navigate(_x38) {
        return _navigate.apply(this, arguments);
      }
      return navigate;
    }()
  }, {
    key: "_dispose",
    value: function _dispose() {
      this._logger.create("_dispose");
      var _iterator5 = _createForOfIteratorHelper(this._disposeHandlers),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var dispose = _step5.value;
          dispose();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      this._disposeHandlers.clear();
    }
  }], [{
    key: "_notifyParent",
    value: function _notifyParent(parent, url) {
      var keepOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var targetOrigin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.location.origin;
      parent.postMessage({
        source: messageSource,
        url: url,
        keepOpen: keepOpen
      }, targetOrigin);
    }
  }]);
  return AbstractChildWindow;
}();

// src/UserManagerSettings.ts
var DefaultPopupWindowFeatures = {
  location: false,
  toolbar: false,
  height: 640
};
var DefaultPopupTarget = "_blank";
var DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var DefaultCheckSessionIntervalInSeconds = 2;
var DefaultSilentRequestTimeoutInSeconds = 10;
var _UserManagerSettingsStore = /*#__PURE__*/function (_OidcClientSettingsSt) {
  _inherits(_UserManagerSettingsStore, _OidcClientSettingsSt);
  var _super5 = _createSuper(_UserManagerSettingsStore);
  function _UserManagerSettingsStore(args) {
    var _this12;
    _classCallCheck(this, _UserManagerSettingsStore);
    var _args$popup_redirect_ = args.popup_redirect_uri,
      popup_redirect_uri = _args$popup_redirect_ === void 0 ? args.redirect_uri : _args$popup_redirect_,
      _args$popup_post_logo = args.popup_post_logout_redirect_uri,
      popup_post_logout_redirect_uri = _args$popup_post_logo === void 0 ? args.post_logout_redirect_uri : _args$popup_post_logo,
      _args$popupWindowFeat = args.popupWindowFeatures,
      popupWindowFeatures = _args$popupWindowFeat === void 0 ? DefaultPopupWindowFeatures : _args$popupWindowFeat,
      _args$popupWindowTarg = args.popupWindowTarget,
      popupWindowTarget = _args$popupWindowTarg === void 0 ? DefaultPopupTarget : _args$popupWindowTarg,
      _args$redirectMethod = args.redirectMethod,
      redirectMethod = _args$redirectMethod === void 0 ? "assign" : _args$redirectMethod,
      _args$redirectTarget = args.redirectTarget,
      redirectTarget = _args$redirectTarget === void 0 ? "self" : _args$redirectTarget,
      _args$iframeNotifyPar = args.iframeNotifyParentOrigin,
      iframeNotifyParentOrigin = _args$iframeNotifyPar === void 0 ? args.iframeNotifyParentOrigin : _args$iframeNotifyPar,
      _args$iframeScriptOri = args.iframeScriptOrigin,
      iframeScriptOrigin = _args$iframeScriptOri === void 0 ? args.iframeScriptOrigin : _args$iframeScriptOri,
      _args$silent_redirect = args.silent_redirect_uri,
      silent_redirect_uri = _args$silent_redirect === void 0 ? args.redirect_uri : _args$silent_redirect,
      _args$silentRequestTi = args.silentRequestTimeoutInSeconds,
      silentRequestTimeoutInSeconds = _args$silentRequestTi === void 0 ? DefaultSilentRequestTimeoutInSeconds : _args$silentRequestTi,
      _args$automaticSilent = args.automaticSilentRenew,
      automaticSilentRenew = _args$automaticSilent === void 0 ? true : _args$automaticSilent,
      _args$validateSubOnSi = args.validateSubOnSilentRenew,
      validateSubOnSilentRenew = _args$validateSubOnSi === void 0 ? true : _args$validateSubOnSi,
      _args$includeIdTokenI = args.includeIdTokenInSilentRenew,
      includeIdTokenInSilentRenew = _args$includeIdTokenI === void 0 ? false : _args$includeIdTokenI,
      _args$monitorSession = args.monitorSession,
      monitorSession = _args$monitorSession === void 0 ? false : _args$monitorSession,
      _args$monitorAnonymou = args.monitorAnonymousSession,
      monitorAnonymousSession = _args$monitorAnonymou === void 0 ? false : _args$monitorAnonymou,
      _args$checkSessionInt = args.checkSessionIntervalInSeconds,
      checkSessionIntervalInSeconds = _args$checkSessionInt === void 0 ? DefaultCheckSessionIntervalInSeconds : _args$checkSessionInt,
      _args$query_status_re = args.query_status_response_type,
      query_status_response_type = _args$query_status_re === void 0 ? "code" : _args$query_status_re,
      _args$stopCheckSessio = args.stopCheckSessionOnError,
      stopCheckSessionOnError = _args$stopCheckSessio === void 0 ? true : _args$stopCheckSessio,
      _args$revokeTokenType = args.revokeTokenTypes,
      revokeTokenTypes = _args$revokeTokenType === void 0 ? ["access_token", "refresh_token"] : _args$revokeTokenType,
      _args$revokeTokensOnS = args.revokeTokensOnSignout,
      revokeTokensOnSignout = _args$revokeTokensOnS === void 0 ? false : _args$revokeTokensOnS,
      _args$includeIdTokenI2 = args.includeIdTokenInSilentSignout,
      includeIdTokenInSilentSignout = _args$includeIdTokenI2 === void 0 ? false : _args$includeIdTokenI2,
      _args$accessTokenExpi = args.accessTokenExpiringNotificationTimeInSeconds,
      accessTokenExpiringNotificationTimeInSeconds = _args$accessTokenExpi === void 0 ? DefaultAccessTokenExpiringNotificationTimeInSeconds : _args$accessTokenExpi,
      userStore = args.userStore;
    _this12 = _super5.call(this, args);
    _this12.popup_redirect_uri = popup_redirect_uri;
    _this12.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
    _this12.popupWindowFeatures = popupWindowFeatures;
    _this12.popupWindowTarget = popupWindowTarget;
    _this12.redirectMethod = redirectMethod;
    _this12.redirectTarget = redirectTarget;
    _this12.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
    _this12.iframeScriptOrigin = iframeScriptOrigin;
    _this12.silent_redirect_uri = silent_redirect_uri;
    _this12.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds;
    _this12.automaticSilentRenew = automaticSilentRenew;
    _this12.validateSubOnSilentRenew = validateSubOnSilentRenew;
    _this12.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
    _this12.monitorSession = monitorSession;
    _this12.monitorAnonymousSession = monitorAnonymousSession;
    _this12.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
    _this12.stopCheckSessionOnError = stopCheckSessionOnError;
    _this12.query_status_response_type = query_status_response_type;
    _this12.revokeTokenTypes = revokeTokenTypes;
    _this12.revokeTokensOnSignout = revokeTokensOnSignout;
    _this12.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
    _this12.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
    if (userStore) {
      _this12.userStore = userStore;
    } else {
      var store = typeof window !== "undefined" ? window.sessionStorage : new _InMemoryWebStorage();
      _this12.userStore = new _WebStorageStateStore({
        store: store
      });
    }
    return _this12;
  }
  return _createClass(_UserManagerSettingsStore);
}(_OidcClientSettingsStore);

// src/navigators/IFrameWindow.ts
var IFrameWindow = /*#__PURE__*/function (_AbstractChildWindow) {
  _inherits(IFrameWindow, _AbstractChildWindow);
  var _super6 = _createSuper(IFrameWindow);
  function IFrameWindow(_ref23) {
    var _this13;
    var _ref23$silentRequestT = _ref23.silentRequestTimeoutInSeconds,
      silentRequestTimeoutInSeconds = _ref23$silentRequestT === void 0 ? DefaultSilentRequestTimeoutInSeconds : _ref23$silentRequestT;
    _classCallCheck(this, IFrameWindow);
    _this13 = _super6.call(this);
    _this13._logger = new _Logger("IFrameWindow");
    _this13._timeoutInSeconds = silentRequestTimeoutInSeconds;
    _this13._frame = IFrameWindow.createHiddenIframe();
    _this13._window = _this13._frame.contentWindow;
    return _this13;
  }
  _createClass(IFrameWindow, [{
    key: "navigate",
    value: function () {
      var _navigate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(params) {
        var _this14 = this;
        var timer;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
              timer = setTimeout(function () {
                return _this14._abort.raise(new _ErrorTimeout("IFrame timed out without a response"));
              }, this._timeoutInSeconds * 1e3);
              this._disposeHandlers.add(function () {
                return clearTimeout(timer);
              });
              _context37.next = 5;
              return _get(_getPrototypeOf(IFrameWindow.prototype), "navigate", this).call(this, params);
            case 5:
              return _context37.abrupt("return", _context37.sent);
            case 6:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
      function navigate(_x39) {
        return _navigate2.apply(this, arguments);
      }
      return navigate;
    }()
  }, {
    key: "close",
    value: function close() {
      var _this15 = this;
      var _a;
      if (this._frame) {
        if (this._frame.parentNode) {
          this._frame.addEventListener("load", function (ev) {
            var _a2;
            var frame = ev.target;
            (_a2 = frame.parentNode) == null ? void 0 : _a2.removeChild(frame);
            _this15._abort.raise(new Error("IFrame removed from DOM"));
          }, true);
          (_a = this._frame.contentWindow) == null ? void 0 : _a.location.replace("about:blank");
        }
        this._frame = null;
      }
      this._window = null;
    }
  }], [{
    key: "createHiddenIframe",
    value: function createHiddenIframe() {
      var iframe = window.document.createElement("iframe");
      iframe.style.visibility = "hidden";
      iframe.style.position = "fixed";
      iframe.style.left = "-1000px";
      iframe.style.top = "0";
      iframe.width = "0";
      iframe.height = "0";
      iframe.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
      window.document.body.appendChild(iframe);
      return iframe;
    }
  }, {
    key: "notifyParent",
    value: function notifyParent(url, targetOrigin) {
      return _get(_getPrototypeOf(IFrameWindow), "_notifyParent", this).call(this, window.parent, url, false, targetOrigin);
    }
  }]);
  return IFrameWindow;
}(AbstractChildWindow);

// src/navigators/IFrameNavigator.ts
var IFrameNavigator = /*#__PURE__*/function () {
  function IFrameNavigator(_settings) {
    _classCallCheck(this, IFrameNavigator);
    this._settings = _settings;
    this._logger = new _Logger("IFrameNavigator");
  }
  _createClass(IFrameNavigator, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(_ref24) {
        var _ref24$silentRequestT, silentRequestTimeoutInSeconds;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _ref24$silentRequestT = _ref24.silentRequestTimeoutInSeconds, silentRequestTimeoutInSeconds = _ref24$silentRequestT === void 0 ? this._settings.silentRequestTimeoutInSeconds : _ref24$silentRequestT;
              return _context38.abrupt("return", new IFrameWindow({
                silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
              }));
            case 2:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function prepare(_x40) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "callback",
    value: function () {
      var _callback2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(url) {
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              this._logger.create("callback");
              IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
            case 2:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this);
      }));
      function callback(_x41) {
        return _callback2.apply(this, arguments);
      }
      return callback;
    }()
  }]);
  return IFrameNavigator;
}();

// src/navigators/PopupWindow.ts
var checkForPopupClosedInterval = 500;
var PopupWindow = /*#__PURE__*/function (_AbstractChildWindow2) {
  _inherits(PopupWindow, _AbstractChildWindow2);
  var _super7 = _createSuper(PopupWindow);
  function PopupWindow(_ref25) {
    var _this16;
    var _ref25$popupWindowTar = _ref25.popupWindowTarget,
      popupWindowTarget = _ref25$popupWindowTar === void 0 ? DefaultPopupTarget : _ref25$popupWindowTar,
      _ref25$popupWindowFea = _ref25.popupWindowFeatures,
      popupWindowFeatures = _ref25$popupWindowFea === void 0 ? {} : _ref25$popupWindowFea;
    _classCallCheck(this, PopupWindow);
    _this16 = _super7.call(this);
    _this16._logger = new _Logger("PopupWindow");
    var centeredPopup = PopupUtils.center(_objectSpread(_objectSpread({}, DefaultPopupWindowFeatures), popupWindowFeatures));
    _this16._window = window.open(void 0, popupWindowTarget, PopupUtils.serialize(centeredPopup));
    return _this16;
  }
  _createClass(PopupWindow, [{
    key: "navigate",
    value: function () {
      var _navigate3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(params) {
        var _this17 = this;
        var _a, popupClosedInterval;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              (_a = this._window) == null ? void 0 : _a.focus();
              popupClosedInterval = setInterval(function () {
                if (!_this17._window || _this17._window.closed) {
                  _this17._abort.raise(new Error("Popup closed by user"));
                }
              }, checkForPopupClosedInterval);
              this._disposeHandlers.add(function () {
                return clearInterval(popupClosedInterval);
              });
              _context40.next = 5;
              return _get(_getPrototypeOf(PopupWindow.prototype), "navigate", this).call(this, params);
            case 5:
              return _context40.abrupt("return", _context40.sent);
            case 6:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
      function navigate(_x42) {
        return _navigate3.apply(this, arguments);
      }
      return navigate;
    }()
  }, {
    key: "close",
    value: function close() {
      if (this._window) {
        if (!this._window.closed) {
          this._window.close();
          this._abort.raise(new Error("Popup closed"));
        }
      }
      this._window = null;
    }
  }], [{
    key: "notifyOpener",
    value: function notifyOpener(url, keepOpen) {
      if (!window.opener) {
        throw new Error("No window.opener. Can't complete notification.");
      }
      return _get(_getPrototypeOf(PopupWindow), "_notifyParent", this).call(this, window.opener, url, keepOpen);
    }
  }]);
  return PopupWindow;
}(AbstractChildWindow);

// src/navigators/PopupNavigator.ts
var PopupNavigator = /*#__PURE__*/function () {
  function PopupNavigator(_settings) {
    _classCallCheck(this, PopupNavigator);
    this._settings = _settings;
    this._logger = new _Logger("PopupNavigator");
  }
  _createClass(PopupNavigator, [{
    key: "prepare",
    value: function () {
      var _prepare2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(_ref26) {
        var _ref26$popupWindowFea, popupWindowFeatures, _ref26$popupWindowTar, popupWindowTarget;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _ref26$popupWindowFea = _ref26.popupWindowFeatures, popupWindowFeatures = _ref26$popupWindowFea === void 0 ? this._settings.popupWindowFeatures : _ref26$popupWindowFea, _ref26$popupWindowTar = _ref26.popupWindowTarget, popupWindowTarget = _ref26$popupWindowTar === void 0 ? this._settings.popupWindowTarget : _ref26$popupWindowTar;
              return _context41.abrupt("return", new PopupWindow({
                popupWindowFeatures: popupWindowFeatures,
                popupWindowTarget: popupWindowTarget
              }));
            case 2:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this);
      }));
      function prepare(_x43) {
        return _prepare2.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "callback",
    value: function () {
      var _callback3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(url) {
        var keepOpen,
          _args42 = arguments;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              keepOpen = _args42.length > 1 && _args42[1] !== undefined ? _args42[1] : false;
              this._logger.create("callback");
              PopupWindow.notifyOpener(url, keepOpen);
            case 3:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this);
      }));
      function callback(_x44) {
        return _callback3.apply(this, arguments);
      }
      return callback;
    }()
  }]);
  return PopupNavigator;
}();

// src/navigators/RedirectNavigator.ts
var RedirectNavigator = /*#__PURE__*/function () {
  function RedirectNavigator(_settings) {
    _classCallCheck(this, RedirectNavigator);
    this._settings = _settings;
    this._logger = new _Logger("RedirectNavigator");
  }
  _createClass(RedirectNavigator, [{
    key: "prepare",
    value: function () {
      var _prepare3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(_ref27) {
        var _this18 = this;
        var _ref27$redirectMethod, redirectMethod, _ref27$redirectTarget, redirectTarget, _a, targetWindow, redirect, abort;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              _ref27$redirectMethod = _ref27.redirectMethod, redirectMethod = _ref27$redirectMethod === void 0 ? this._settings.redirectMethod : _ref27$redirectMethod, _ref27$redirectTarget = _ref27.redirectTarget, redirectTarget = _ref27$redirectTarget === void 0 ? this._settings.redirectTarget : _ref27$redirectTarget;
              this._logger.create("prepare");
              targetWindow = window.self;
              if (redirectTarget === "top") {
                targetWindow = (_a = window.top) != null ? _a : window.self;
              }
              redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
              return _context44.abrupt("return", {
                navigate: function () {
                  var _navigate4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(params) {
                    var promise;
                    return _regeneratorRuntime().wrap(function _callee43$(_context43) {
                      while (1) switch (_context43.prev = _context43.next) {
                        case 0:
                          _this18._logger.create("navigate");
                          promise = new Promise(function (resolve, reject) {
                            abort = reject;
                          });
                          redirect(params.url);
                          _context43.next = 5;
                          return promise;
                        case 5:
                          return _context43.abrupt("return", _context43.sent);
                        case 6:
                        case "end":
                          return _context43.stop();
                      }
                    }, _callee43);
                  }));
                  function navigate(_x46) {
                    return _navigate4.apply(this, arguments);
                  }
                  return navigate;
                }(),
                close: function close() {
                  _this18._logger.create("close");
                  abort == null ? void 0 : abort(new Error("Redirect aborted"));
                  targetWindow.stop();
                }
              });
            case 6:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
      function prepare(_x45) {
        return _prepare3.apply(this, arguments);
      }
      return prepare;
    }()
  }]);
  return RedirectNavigator;
}();

// src/UserManagerEvents.ts
var UserManagerEvents = /*#__PURE__*/function (_AccessTokenEvents2) {
  _inherits(UserManagerEvents, _AccessTokenEvents2);
  var _super8 = _createSuper(UserManagerEvents);
  function UserManagerEvents(settings) {
    var _this19;
    _classCallCheck(this, UserManagerEvents);
    _this19 = _super8.call(this, {
      expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds
    });
    _this19._logger = new _Logger("UserManagerEvents");
    _this19._userLoaded = new Event("User loaded");
    _this19._userUnloaded = new Event("User unloaded");
    _this19._silentRenewError = new Event("Silent renew error");
    _this19._userSignedIn = new Event("User signed in");
    _this19._userSignedOut = new Event("User signed out");
    _this19._userSessionChanged = new Event("User session changed");
    return _this19;
  }
  _createClass(UserManagerEvents, [{
    key: "load",
    value: function load(user) {
      var raiseEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _get(_getPrototypeOf(UserManagerEvents.prototype), "load", this).call(this, user);
      if (raiseEvent) {
        this._userLoaded.raise(user);
      }
    }
  }, {
    key: "unload",
    value: function unload() {
      _get(_getPrototypeOf(UserManagerEvents.prototype), "unload", this).call(this);
      this._userUnloaded.raise();
    }
    /**
     * Add callback: Raised when a user session has been established (or re-established).
     */
  }, {
    key: "addUserLoaded",
    value: function addUserLoaded(cb) {
      return this._userLoaded.addHandler(cb);
    }
    /**
     * Remove callback: Raised when a user session has been established (or re-established).
     */
  }, {
    key: "removeUserLoaded",
    value: function removeUserLoaded(cb) {
      return this._userLoaded.removeHandler(cb);
    }
    /**
     * Add callback: Raised when a user session has been terminated.
     */
  }, {
    key: "addUserUnloaded",
    value: function addUserUnloaded(cb) {
      return this._userUnloaded.addHandler(cb);
    }
    /**
     * Remove callback: Raised when a user session has been terminated.
     */
  }, {
    key: "removeUserUnloaded",
    value: function removeUserUnloaded(cb) {
      return this._userUnloaded.removeHandler(cb);
    }
    /**
     * Add callback: Raised when the automatic silent renew has failed.
     */
  }, {
    key: "addSilentRenewError",
    value: function addSilentRenewError(cb) {
      return this._silentRenewError.addHandler(cb);
    }
    /**
     * Remove callback: Raised when the automatic silent renew has failed.
     */
  }, {
    key: "removeSilentRenewError",
    value: function removeSilentRenewError(cb) {
      return this._silentRenewError.removeHandler(cb);
    }
    /**
     * @internal
     */
  }, {
    key: "_raiseSilentRenewError",
    value: function _raiseSilentRenewError(e) {
      this._silentRenewError.raise(e);
    }
    /**
     * Add callback: Raised when the user is signed in (when `monitorSession` is set).
     * @see {@link UserManagerSettings.monitorSession}
     */
  }, {
    key: "addUserSignedIn",
    value: function addUserSignedIn(cb) {
      return this._userSignedIn.addHandler(cb);
    }
    /**
     * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
     */
  }, {
    key: "removeUserSignedIn",
    value: function removeUserSignedIn(cb) {
      this._userSignedIn.removeHandler(cb);
    }
    /**
     * @internal
     */
  }, {
    key: "_raiseUserSignedIn",
    value: function _raiseUserSignedIn() {
      this._userSignedIn.raise();
    }
    /**
     * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
     * @see {@link UserManagerSettings.monitorSession}
     */
  }, {
    key: "addUserSignedOut",
    value: function addUserSignedOut(cb) {
      return this._userSignedOut.addHandler(cb);
    }
    /**
     * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
     */
  }, {
    key: "removeUserSignedOut",
    value: function removeUserSignedOut(cb) {
      this._userSignedOut.removeHandler(cb);
    }
    /**
     * @internal
     */
  }, {
    key: "_raiseUserSignedOut",
    value: function _raiseUserSignedOut() {
      this._userSignedOut.raise();
    }
    /**
     * Add callback: Raised when the user session changed (when `monitorSession` is set).
     * @see {@link UserManagerSettings.monitorSession}
     */
  }, {
    key: "addUserSessionChanged",
    value: function addUserSessionChanged(cb) {
      return this._userSessionChanged.addHandler(cb);
    }
    /**
     * Remove callback: Raised when the user session changed (when `monitorSession` is set).
     */
  }, {
    key: "removeUserSessionChanged",
    value: function removeUserSessionChanged(cb) {
      this._userSessionChanged.removeHandler(cb);
    }
    /**
     * @internal
     */
  }, {
    key: "_raiseUserSessionChanged",
    value: function _raiseUserSessionChanged() {
      this._userSessionChanged.raise();
    }
  }]);
  return UserManagerEvents;
}(_AccessTokenEvents);

// src/SilentRenewService.ts
var SilentRenewService = /*#__PURE__*/function () {
  function SilentRenewService(_userManager) {
    var _this20 = this;
    _classCallCheck(this, SilentRenewService);
    this._userManager = _userManager;
    this._logger = new _Logger("SilentRenewService");
    this._isStarted = false;
    this._retryTimer = new Timer("Retry Silent Renew");
    this._tokenExpiring = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
      var logger2;
      return _regeneratorRuntime().wrap(function _callee45$(_context45) {
        while (1) switch (_context45.prev = _context45.next) {
          case 0:
            logger2 = _this20._logger.create("_tokenExpiring");
            _context45.prev = 1;
            _context45.next = 4;
            return _this20._userManager.signinSilent();
          case 4:
            logger2.debug("silent token renewal successful");
            _context45.next = 15;
            break;
          case 7:
            _context45.prev = 7;
            _context45.t0 = _context45["catch"](1);
            if (!(_context45.t0 instanceof _ErrorTimeout)) {
              _context45.next = 13;
              break;
            }
            logger2.warn("ErrorTimeout from signinSilent:", _context45.t0, "retry in 5s");
            _this20._retryTimer.init(5);
            return _context45.abrupt("return");
          case 13:
            logger2.error("Error from signinSilent:", _context45.t0);
            _this20._userManager.events._raiseSilentRenewError(_context45.t0);
          case 15:
          case "end":
            return _context45.stop();
        }
      }, _callee45, null, [[1, 7]]);
    }));
  }
  _createClass(SilentRenewService, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var logger2;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              logger2 = this._logger.create("start");
              if (this._isStarted) {
                _context46.next = 13;
                break;
              }
              this._isStarted = true;
              this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
              this._retryTimer.addHandler(this._tokenExpiring);
              _context46.prev = 5;
              _context46.next = 8;
              return this._userManager.getUser();
            case 8:
              _context46.next = 13;
              break;
            case 10:
              _context46.prev = 10;
              _context46.t0 = _context46["catch"](5);
              logger2.error("getUser error", _context46.t0);
            case 13:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this, [[5, 10]]);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (this._isStarted) {
        this._retryTimer.cancel();
        this._retryTimer.removeHandler(this._tokenExpiring);
        this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
        this._isStarted = false;
      }
    }
  }]);
  return SilentRenewService;
}();

// src/RefreshState.ts
var RefreshState = /*#__PURE__*/_createClass(function RefreshState(args) {
  _classCallCheck(this, RefreshState);
  this.refresh_token = args.refresh_token;
  this.id_token = args.id_token;
  this.session_state = args.session_state;
  this.scope = args.scope;
  this.profile = args.profile;
  this.data = args.state;
});

// src/UserManager.ts
var _UserManager = /*#__PURE__*/function () {
  function _UserManager(settings) {
    _classCallCheck(this, _UserManager);
    this._logger = new _Logger("UserManager");
    this.settings = new _UserManagerSettingsStore(settings);
    this._client = new _OidcClient(settings);
    this._redirectNavigator = new RedirectNavigator(this.settings);
    this._popupNavigator = new PopupNavigator(this.settings);
    this._iframeNavigator = new IFrameNavigator(this.settings);
    this._events = new UserManagerEvents(this.settings);
    this._silentRenewService = new SilentRenewService(this);
    if (this.settings.automaticSilentRenew) {
      this.startSilentRenew();
    }
    this._sessionMonitor = null;
    if (this.settings.monitorSession) {
      this._sessionMonitor = new _SessionMonitor(this);
    }
  }
  /** Returns an object used to register for events raised by the `UserManager`. */
  _createClass(_UserManager, [{
    key: "events",
    get: function get() {
      return this._events;
    }
    /** Returns an object used to access the metadata configuration of the OIDC provider. */
  }, {
    key: "metadataService",
    get: function get() {
      return this._client.metadataService;
    }
    /**
     * Returns promise to load the `User` object for the currently authenticated user.
     */
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        var logger2, user;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              logger2 = this._logger.create("getUser");
              _context47.next = 3;
              return this._loadUser();
            case 3:
              user = _context47.sent;
              if (!user) {
                _context47.next = 8;
                break;
              }
              logger2.info("user loaded");
              this._events.load(user, false);
              return _context47.abrupt("return", user);
            case 8:
              logger2.info("user not found in storage");
              return _context47.abrupt("return", null);
            case 10:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this);
      }));
      function getUser() {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
    /**
     * Returns promise to remove from any storage the currently authenticated user.
     */
  }, {
    key: "removeUser",
    value: function () {
      var _removeUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var logger2;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              logger2 = this._logger.create("removeUser");
              _context48.next = 3;
              return this.storeUser(null);
            case 3:
              logger2.info("user removed from storage");
              this._events.unload();
            case 5:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function removeUser() {
        return _removeUser.apply(this, arguments);
      }
      return removeUser;
    }()
    /**
     * Returns promise to trigger a redirect of the current window to the authorization endpoint.
     */
  }, {
    key: "signinRedirect",
    value: function () {
      var _signinRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        var args,
          redirectMethod,
          requestArgs,
          handle,
          _args49 = arguments;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              args = _args49.length > 0 && _args49[0] !== undefined ? _args49[0] : {};
              this._logger.create("signinRedirect");
              redirectMethod = args.redirectMethod, requestArgs = _objectWithoutProperties(args, _excluded6);
              _context49.next = 5;
              return this._redirectNavigator.prepare({
                redirectMethod: redirectMethod
              });
            case 5:
              handle = _context49.sent;
              _context49.next = 8;
              return this._signinStart(_objectSpread({
                request_type: "si:r"
              }, requestArgs), handle);
            case 8:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this);
      }));
      function signinRedirect() {
        return _signinRedirect.apply(this, arguments);
      }
      return signinRedirect;
    }()
    /**
     * Returns promise to process response from the authorization endpoint. The result of the promise is the authenticated `User`.
     */
  }, {
    key: "signinRedirectCallback",
    value: function () {
      var _signinRedirectCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
        var url,
          logger2,
          user,
          _args50 = arguments;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              url = _args50.length > 0 && _args50[0] !== undefined ? _args50[0] : window.location.href;
              logger2 = this._logger.create("signinRedirectCallback");
              _context50.next = 4;
              return this._signinEnd(url);
            case 4:
              user = _context50.sent;
              if (user.profile && user.profile.sub) {
                logger2.info("success, signed in subject", user.profile.sub);
              } else {
                logger2.info("no subject");
              }
              return _context50.abrupt("return", user);
            case 7:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function signinRedirectCallback() {
        return _signinRedirectCallback.apply(this, arguments);
      }
      return signinRedirectCallback;
    }()
    /**
     * Returns promise to process the signin with user/password. The result of the promise is the authenticated `User`.
     *
     * Throws an ErrorResponse in case of wrong authentication.
     */
  }, {
    key: "signinResourceOwnerCredentials",
    value: function () {
      var _signinResourceOwnerCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(_ref29) {
        var username, password, _ref29$skipUserInfo, skipUserInfo, logger2, signinResponse, user;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              username = _ref29.username, password = _ref29.password, _ref29$skipUserInfo = _ref29.skipUserInfo, skipUserInfo = _ref29$skipUserInfo === void 0 ? false : _ref29$skipUserInfo;
              logger2 = this._logger.create("signinResourceOwnerCredential");
              _context51.next = 4;
              return this._client.processResourceOwnerPasswordCredentials({
                username: username,
                password: password,
                skipUserInfo: skipUserInfo,
                extraTokenParams: this.settings.extraTokenParams
              });
            case 4:
              signinResponse = _context51.sent;
              logger2.debug("got signin response");
              _context51.next = 8;
              return this._buildUser(signinResponse);
            case 8:
              user = _context51.sent;
              if (user.profile && user.profile.sub) {
                logger2.info("success, signed in subject", user.profile.sub);
              } else {
                logger2.info("no subject");
              }
              return _context51.abrupt("return", user);
            case 11:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this);
      }));
      function signinResourceOwnerCredentials(_x47) {
        return _signinResourceOwnerCredentials.apply(this, arguments);
      }
      return signinResourceOwnerCredentials;
    }()
    /**
     * Returns promise to trigger a request (via a popup window) to the authorization endpoint. The result of the promise is the authenticated `User`.
     */
  }, {
    key: "signinPopup",
    value: function () {
      var _signinPopup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
        var args,
          logger2,
          popupWindowFeatures,
          popupWindowTarget,
          requestArgs,
          url,
          handle,
          user,
          _args52 = arguments;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              args = _args52.length > 0 && _args52[0] !== undefined ? _args52[0] : {};
              logger2 = this._logger.create("signinPopup");
              popupWindowFeatures = args.popupWindowFeatures, popupWindowTarget = args.popupWindowTarget, requestArgs = _objectWithoutProperties(args, _excluded7);
              url = this.settings.popup_redirect_uri;
              if (!url) {
                logger2["throw"](new Error("No popup_redirect_uri configured"));
              }
              _context52.next = 7;
              return this._popupNavigator.prepare({
                popupWindowFeatures: popupWindowFeatures,
                popupWindowTarget: popupWindowTarget
              });
            case 7:
              handle = _context52.sent;
              _context52.next = 10;
              return this._signin(_objectSpread({
                request_type: "si:p",
                redirect_uri: url,
                display: "popup"
              }, requestArgs), handle);
            case 10:
              user = _context52.sent;
              if (user) {
                if (user.profile && user.profile.sub) {
                  logger2.info("success, signed in subject", user.profile.sub);
                } else {
                  logger2.info("no subject");
                }
              }
              return _context52.abrupt("return", user);
            case 13:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this);
      }));
      function signinPopup() {
        return _signinPopup.apply(this, arguments);
      }
      return signinPopup;
    }()
    /**
     * Returns promise to notify the opening window of response from the authorization endpoint.
     */
  }, {
    key: "signinPopupCallback",
    value: function () {
      var _signinPopupCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
        var url,
          keepOpen,
          logger2,
          _args53 = arguments;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              url = _args53.length > 0 && _args53[0] !== undefined ? _args53[0] : window.location.href;
              keepOpen = _args53.length > 1 && _args53[1] !== undefined ? _args53[1] : false;
              logger2 = this._logger.create("signinPopupCallback");
              _context53.next = 5;
              return this._popupNavigator.callback(url, keepOpen);
            case 5:
              logger2.info("success");
            case 6:
            case "end":
              return _context53.stop();
          }
        }, _callee53, this);
      }));
      function signinPopupCallback() {
        return _signinPopupCallback.apply(this, arguments);
      }
      return signinPopupCallback;
    }()
    /**
     * Returns promise to trigger a silent request (via an iframe) to the authorization endpoint.
     * The result of the promise is the authenticated `User`.
     */
  }, {
    key: "signinSilent",
    value: function () {
      var _signinSilent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
        var args,
          _a,
          logger2,
          silentRequestTimeoutInSeconds,
          requestArgs,
          user,
          state,
          url,
          verifySub,
          handle,
          _args54 = arguments;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              args = _args54.length > 0 && _args54[0] !== undefined ? _args54[0] : {};
              logger2 = this._logger.create("signinSilent");
              silentRequestTimeoutInSeconds = args.silentRequestTimeoutInSeconds, requestArgs = _objectWithoutProperties(args, _excluded8);
              _context54.next = 5;
              return this._loadUser();
            case 5:
              user = _context54.sent;
              if (!(user == null ? void 0 : user.refresh_token)) {
                _context54.next = 12;
                break;
              }
              logger2.debug("using refresh token");
              state = new RefreshState(user);
              _context54.next = 11;
              return this._useRefreshToken(state);
            case 11:
              return _context54.abrupt("return", _context54.sent);
            case 12:
              url = this.settings.silent_redirect_uri;
              if (!url) {
                logger2["throw"](new Error("No silent_redirect_uri configured"));
              }
              if (user && this.settings.validateSubOnSilentRenew) {
                logger2.debug("subject prior to silent renew:", user.profile.sub);
                verifySub = user.profile.sub;
              }
              _context54.next = 17;
              return this._iframeNavigator.prepare({
                silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
              });
            case 17:
              handle = _context54.sent;
              _context54.next = 20;
              return this._signin(_objectSpread({
                request_type: "si:s",
                redirect_uri: url,
                prompt: "none",
                id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0
              }, requestArgs), handle, verifySub);
            case 20:
              user = _context54.sent;
              if (user) {
                if ((_a = user.profile) == null ? void 0 : _a.sub) {
                  logger2.info("success, signed in subject", user.profile.sub);
                } else {
                  logger2.info("no subject");
                }
              }
              return _context54.abrupt("return", user);
            case 23:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
      function signinSilent() {
        return _signinSilent.apply(this, arguments);
      }
      return signinSilent;
    }()
  }, {
    key: "_useRefreshToken",
    value: function () {
      var _useRefreshToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55(state) {
        var response, user;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _context55.next = 2;
              return this._client.useRefreshToken({
                state: state,
                timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds
              });
            case 2:
              response = _context55.sent;
              user = new _User(_objectSpread(_objectSpread({}, state), response));
              _context55.next = 6;
              return this.storeUser(user);
            case 6:
              this._events.load(user);
              return _context55.abrupt("return", user);
            case 8:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this);
      }));
      function _useRefreshToken(_x48) {
        return _useRefreshToken2.apply(this, arguments);
      }
      return _useRefreshToken;
    }()
    /**
     * Returns promise to notify the parent window of response from the authorization endpoint.
     */
  }, {
    key: "signinSilentCallback",
    value: function () {
      var _signinSilentCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        var url,
          logger2,
          _args56 = arguments;
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              url = _args56.length > 0 && _args56[0] !== undefined ? _args56[0] : window.location.href;
              logger2 = this._logger.create("signinSilentCallback");
              _context56.next = 4;
              return this._iframeNavigator.callback(url);
            case 4:
              logger2.info("success");
            case 5:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this);
      }));
      function signinSilentCallback() {
        return _signinSilentCallback.apply(this, arguments);
      }
      return signinSilentCallback;
    }()
  }, {
    key: "signinCallback",
    value: function () {
      var _signinCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
        var url,
          _yield$this$_client$r,
          state,
          _args57 = arguments;
        return _regeneratorRuntime().wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              url = _args57.length > 0 && _args57[0] !== undefined ? _args57[0] : window.location.href;
              _context57.next = 3;
              return this._client.readSigninResponseState(url);
            case 3:
              _yield$this$_client$r = _context57.sent;
              state = _yield$this$_client$r.state;
              _context57.t0 = state.request_type;
              _context57.next = _context57.t0 === "si:r" ? 8 : _context57.t0 === "si:p" ? 11 : _context57.t0 === "si:s" ? 14 : 17;
              break;
            case 8:
              _context57.next = 10;
              return this.signinRedirectCallback(url);
            case 10:
              return _context57.abrupt("return", _context57.sent);
            case 11:
              _context57.next = 13;
              return this.signinPopupCallback(url);
            case 13:
              return _context57.abrupt("return", _context57.sent);
            case 14:
              _context57.next = 16;
              return this.signinSilentCallback(url);
            case 16:
              return _context57.abrupt("return", _context57.sent);
            case 17:
              throw new Error("invalid response_type in state");
            case 18:
            case "end":
              return _context57.stop();
          }
        }, _callee57, this);
      }));
      function signinCallback() {
        return _signinCallback.apply(this, arguments);
      }
      return signinCallback;
    }()
  }, {
    key: "signoutCallback",
    value: function () {
      var _signoutCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var url,
          keepOpen,
          _yield$this$_client$r2,
          state,
          _args58 = arguments;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              url = _args58.length > 0 && _args58[0] !== undefined ? _args58[0] : window.location.href;
              keepOpen = _args58.length > 1 && _args58[1] !== undefined ? _args58[1] : false;
              _context58.next = 4;
              return this._client.readSignoutResponseState(url);
            case 4:
              _yield$this$_client$r2 = _context58.sent;
              state = _yield$this$_client$r2.state;
              if (state) {
                _context58.next = 8;
                break;
              }
              return _context58.abrupt("return");
            case 8:
              _context58.t0 = state.request_type;
              _context58.next = _context58.t0 === "so:r" ? 11 : _context58.t0 === "so:p" ? 14 : _context58.t0 === "so:s" ? 17 : 20;
              break;
            case 11:
              _context58.next = 13;
              return this.signoutRedirectCallback(url);
            case 13:
              return _context58.abrupt("break", 21);
            case 14:
              _context58.next = 16;
              return this.signoutPopupCallback(url, keepOpen);
            case 16:
              return _context58.abrupt("break", 21);
            case 17:
              _context58.next = 19;
              return this.signoutSilentCallback(url);
            case 19:
              return _context58.abrupt("break", 21);
            case 20:
              throw new Error("invalid response_type in state");
            case 21:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this);
      }));
      function signoutCallback() {
        return _signoutCallback.apply(this, arguments);
      }
      return signoutCallback;
    }()
    /**
     * Returns promise to query OP for user's current signin status. Returns object with session_state and subject identifier.
     */
  }, {
    key: "querySessionStatus",
    value: function () {
      var _querySessionStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
        var args,
          logger2,
          silentRequestTimeoutInSeconds,
          requestArgs,
          url,
          user,
          handle,
          navResponse,
          signinResponse,
          _args59 = arguments;
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              args = _args59.length > 0 && _args59[0] !== undefined ? _args59[0] : {};
              logger2 = this._logger.create("querySessionStatus");
              silentRequestTimeoutInSeconds = args.silentRequestTimeoutInSeconds, requestArgs = _objectWithoutProperties(args, _excluded9);
              url = this.settings.silent_redirect_uri;
              if (!url) {
                logger2["throw"](new Error("No silent_redirect_uri configured"));
              }
              _context59.next = 7;
              return this._loadUser();
            case 7:
              user = _context59.sent;
              _context59.next = 10;
              return this._iframeNavigator.prepare({
                silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
              });
            case 10:
              handle = _context59.sent;
              _context59.next = 13;
              return this._signinStart(_objectSpread({
                request_type: "si:s",
                // this acts like a signin silent
                redirect_uri: url,
                prompt: "none",
                id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
                response_type: this.settings.query_status_response_type,
                scope: "openid",
                skipUserInfo: true
              }, requestArgs), handle);
            case 13:
              navResponse = _context59.sent;
              _context59.prev = 14;
              _context59.next = 17;
              return this._client.processSigninResponse(navResponse.url);
            case 17:
              signinResponse = _context59.sent;
              logger2.debug("got signin response");
              if (!(signinResponse.session_state && signinResponse.profile.sub)) {
                _context59.next = 22;
                break;
              }
              logger2.info("success for subject", signinResponse.profile.sub);
              return _context59.abrupt("return", {
                session_state: signinResponse.session_state,
                sub: signinResponse.profile.sub,
                sid: signinResponse.profile.sid
              });
            case 22:
              logger2.info("success, user not authenticated");
              return _context59.abrupt("return", null);
            case 26:
              _context59.prev = 26;
              _context59.t0 = _context59["catch"](14);
              if (!(this.settings.monitorAnonymousSession && _context59.t0 instanceof _ErrorResponse)) {
                _context59.next = 34;
                break;
              }
              _context59.t1 = _context59.t0.error;
              _context59.next = _context59.t1 === "login_required" ? 32 : _context59.t1 === "consent_required" ? 32 : _context59.t1 === "interaction_required" ? 32 : _context59.t1 === "account_selection_required" ? 32 : 34;
              break;
            case 32:
              logger2.info("success for anonymous user");
              return _context59.abrupt("return", {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                session_state: _context59.t0.session_state
              });
            case 34:
              throw _context59.t0;
            case 35:
            case "end":
              return _context59.stop();
          }
        }, _callee59, this, [[14, 26]]);
      }));
      function querySessionStatus() {
        return _querySessionStatus.apply(this, arguments);
      }
      return querySessionStatus;
    }()
  }, {
    key: "_signin",
    value: function () {
      var _signin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(args, handle, verifySub) {
        var navResponse;
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return this._signinStart(args, handle);
            case 2:
              navResponse = _context60.sent;
              _context60.next = 5;
              return this._signinEnd(navResponse.url, verifySub);
            case 5:
              return _context60.abrupt("return", _context60.sent);
            case 6:
            case "end":
              return _context60.stop();
          }
        }, _callee60, this);
      }));
      function _signin(_x49, _x50, _x51) {
        return _signin2.apply(this, arguments);
      }
      return _signin;
    }()
  }, {
    key: "_signinStart",
    value: function () {
      var _signinStart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61(args, handle) {
        var logger2, signinRequest;
        return _regeneratorRuntime().wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              logger2 = this._logger.create("_signinStart");
              _context61.prev = 1;
              _context61.next = 4;
              return this._client.createSigninRequest(args);
            case 4:
              signinRequest = _context61.sent;
              logger2.debug("got signin request");
              _context61.next = 8;
              return handle.navigate({
                url: signinRequest.url,
                state: signinRequest.state.id,
                response_mode: signinRequest.state.response_mode,
                scriptOrigin: this.settings.iframeScriptOrigin
              });
            case 8:
              return _context61.abrupt("return", _context61.sent);
            case 11:
              _context61.prev = 11;
              _context61.t0 = _context61["catch"](1);
              logger2.debug("error after preparing navigator, closing navigator window");
              handle.close();
              throw _context61.t0;
            case 16:
            case "end":
              return _context61.stop();
          }
        }, _callee61, this, [[1, 11]]);
      }));
      function _signinStart(_x52, _x53) {
        return _signinStart2.apply(this, arguments);
      }
      return _signinStart;
    }()
  }, {
    key: "_signinEnd",
    value: function () {
      var _signinEnd2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee62(url, verifySub) {
        var logger2, signinResponse, user;
        return _regeneratorRuntime().wrap(function _callee62$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              logger2 = this._logger.create("_signinEnd");
              _context62.next = 3;
              return this._client.processSigninResponse(url);
            case 3:
              signinResponse = _context62.sent;
              logger2.debug("got signin response");
              _context62.next = 7;
              return this._buildUser(signinResponse, verifySub);
            case 7:
              user = _context62.sent;
              return _context62.abrupt("return", user);
            case 9:
            case "end":
              return _context62.stop();
          }
        }, _callee62, this);
      }));
      function _signinEnd(_x54, _x55) {
        return _signinEnd2.apply(this, arguments);
      }
      return _signinEnd;
    }()
  }, {
    key: "_buildUser",
    value: function () {
      var _buildUser2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee63(signinResponse, verifySub) {
        var logger2, user;
        return _regeneratorRuntime().wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              logger2 = this._logger.create("_buildUser");
              user = new _User(signinResponse);
              if (!verifySub) {
                _context63.next = 7;
                break;
              }
              if (!(verifySub !== user.profile.sub)) {
                _context63.next = 6;
                break;
              }
              logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
              throw new _ErrorResponse(_objectSpread(_objectSpread({}, signinResponse), {}, {
                error: "login_required"
              }));
            case 6:
              logger2.debug("current user matches user returned from signin");
            case 7:
              _context63.next = 9;
              return this.storeUser(user);
            case 9:
              logger2.debug("user stored");
              this._events.load(user);
              return _context63.abrupt("return", user);
            case 12:
            case "end":
              return _context63.stop();
          }
        }, _callee63, this);
      }));
      function _buildUser(_x56, _x57) {
        return _buildUser2.apply(this, arguments);
      }
      return _buildUser;
    }()
    /**
     * Returns promise to trigger a redirect of the current window to the end session endpoint.
     */
  }, {
    key: "signoutRedirect",
    value: function () {
      var _signoutRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
        var args,
          logger2,
          redirectMethod,
          requestArgs,
          handle,
          _args64 = arguments;
        return _regeneratorRuntime().wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              args = _args64.length > 0 && _args64[0] !== undefined ? _args64[0] : {};
              logger2 = this._logger.create("signoutRedirect");
              redirectMethod = args.redirectMethod, requestArgs = _objectWithoutProperties(args, _excluded10);
              _context64.next = 5;
              return this._redirectNavigator.prepare({
                redirectMethod: redirectMethod
              });
            case 5:
              handle = _context64.sent;
              _context64.next = 8;
              return this._signoutStart(_objectSpread({
                request_type: "so:r",
                post_logout_redirect_uri: this.settings.post_logout_redirect_uri
              }, requestArgs), handle);
            case 8:
              logger2.info("success");
            case 9:
            case "end":
              return _context64.stop();
          }
        }, _callee64, this);
      }));
      function signoutRedirect() {
        return _signoutRedirect.apply(this, arguments);
      }
      return signoutRedirect;
    }()
    /**
     * Returns promise to process response from the end session endpoint.
     */
  }, {
    key: "signoutRedirectCallback",
    value: function () {
      var _signoutRedirectCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
        var url,
          logger2,
          response,
          _args65 = arguments;
        return _regeneratorRuntime().wrap(function _callee65$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              url = _args65.length > 0 && _args65[0] !== undefined ? _args65[0] : window.location.href;
              logger2 = this._logger.create("signoutRedirectCallback");
              _context65.next = 4;
              return this._signoutEnd(url);
            case 4:
              response = _context65.sent;
              logger2.info("success");
              return _context65.abrupt("return", response);
            case 7:
            case "end":
              return _context65.stop();
          }
        }, _callee65, this);
      }));
      function signoutRedirectCallback() {
        return _signoutRedirectCallback.apply(this, arguments);
      }
      return signoutRedirectCallback;
    }()
    /**
     * Returns promise to trigger a redirect of a popup window window to the end session endpoint.
     */
  }, {
    key: "signoutPopup",
    value: function () {
      var _signoutPopup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
        var args,
          logger2,
          popupWindowFeatures,
          popupWindowTarget,
          requestArgs,
          url,
          handle,
          _args66 = arguments;
        return _regeneratorRuntime().wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              args = _args66.length > 0 && _args66[0] !== undefined ? _args66[0] : {};
              logger2 = this._logger.create("signoutPopup");
              popupWindowFeatures = args.popupWindowFeatures, popupWindowTarget = args.popupWindowTarget, requestArgs = _objectWithoutProperties(args, _excluded11);
              url = this.settings.popup_post_logout_redirect_uri;
              _context66.next = 6;
              return this._popupNavigator.prepare({
                popupWindowFeatures: popupWindowFeatures,
                popupWindowTarget: popupWindowTarget
              });
            case 6:
              handle = _context66.sent;
              _context66.next = 9;
              return this._signout(_objectSpread({
                request_type: "so:p",
                post_logout_redirect_uri: url,
                // we're putting a dummy entry in here because we
                // need a unique id from the state for notification
                // to the parent window, which is necessary if we
                // plan to return back to the client after signout
                // and so we can close the popup after signout
                state: url == null ? void 0 : {}
              }, requestArgs), handle);
            case 9:
              logger2.info("success");
            case 10:
            case "end":
              return _context66.stop();
          }
        }, _callee66, this);
      }));
      function signoutPopup() {
        return _signoutPopup.apply(this, arguments);
      }
      return signoutPopup;
    }()
    /**
     * Returns promise to process response from the end session endpoint from a popup window.
     */
  }, {
    key: "signoutPopupCallback",
    value: function () {
      var _signoutPopupCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
        var url,
          keepOpen,
          logger2,
          _args67 = arguments;
        return _regeneratorRuntime().wrap(function _callee67$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              url = _args67.length > 0 && _args67[0] !== undefined ? _args67[0] : window.location.href;
              keepOpen = _args67.length > 1 && _args67[1] !== undefined ? _args67[1] : false;
              logger2 = this._logger.create("signoutPopupCallback");
              _context67.next = 5;
              return this._popupNavigator.callback(url, keepOpen);
            case 5:
              logger2.info("success");
            case 6:
            case "end":
              return _context67.stop();
          }
        }, _callee67, this);
      }));
      function signoutPopupCallback() {
        return _signoutPopupCallback.apply(this, arguments);
      }
      return signoutPopupCallback;
    }()
  }, {
    key: "_signout",
    value: function () {
      var _signout2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee68(args, handle) {
        var navResponse;
        return _regeneratorRuntime().wrap(function _callee68$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              _context68.next = 2;
              return this._signoutStart(args, handle);
            case 2:
              navResponse = _context68.sent;
              _context68.next = 5;
              return this._signoutEnd(navResponse.url);
            case 5:
              return _context68.abrupt("return", _context68.sent);
            case 6:
            case "end":
              return _context68.stop();
          }
        }, _callee68, this);
      }));
      function _signout(_x58, _x59) {
        return _signout2.apply(this, arguments);
      }
      return _signout;
    }()
  }, {
    key: "_signoutStart",
    value: function () {
      var _signoutStart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
        var args,
          handle,
          _a,
          logger2,
          user,
          id_token,
          signoutRequest,
          _args69 = arguments;
        return _regeneratorRuntime().wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              args = _args69.length > 0 && _args69[0] !== undefined ? _args69[0] : {};
              handle = _args69.length > 1 ? _args69[1] : undefined;
              logger2 = this._logger.create("_signoutStart");
              _context69.prev = 3;
              _context69.next = 6;
              return this._loadUser();
            case 6:
              user = _context69.sent;
              logger2.debug("loaded current user from storage");
              if (!this.settings.revokeTokensOnSignout) {
                _context69.next = 11;
                break;
              }
              _context69.next = 11;
              return this._revokeInternal(user);
            case 11:
              id_token = args.id_token_hint || user && user.id_token;
              if (id_token) {
                logger2.debug("setting id_token_hint in signout request");
                args.id_token_hint = id_token;
              }
              _context69.next = 15;
              return this.removeUser();
            case 15:
              logger2.debug("user removed, creating signout request");
              _context69.next = 18;
              return this._client.createSignoutRequest(args);
            case 18:
              signoutRequest = _context69.sent;
              logger2.debug("got signout request");
              _context69.next = 22;
              return handle.navigate({
                url: signoutRequest.url,
                state: (_a = signoutRequest.state) == null ? void 0 : _a.id
              });
            case 22:
              return _context69.abrupt("return", _context69.sent);
            case 25:
              _context69.prev = 25;
              _context69.t0 = _context69["catch"](3);
              logger2.debug("error after preparing navigator, closing navigator window");
              handle.close();
              throw _context69.t0;
            case 30:
            case "end":
              return _context69.stop();
          }
        }, _callee69, this, [[3, 25]]);
      }));
      function _signoutStart() {
        return _signoutStart2.apply(this, arguments);
      }
      return _signoutStart;
    }()
  }, {
    key: "_signoutEnd",
    value: function () {
      var _signoutEnd2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee70(url) {
        var logger2, signoutResponse;
        return _regeneratorRuntime().wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              logger2 = this._logger.create("_signoutEnd");
              _context70.next = 3;
              return this._client.processSignoutResponse(url);
            case 3:
              signoutResponse = _context70.sent;
              logger2.debug("got signout response");
              return _context70.abrupt("return", signoutResponse);
            case 6:
            case "end":
              return _context70.stop();
          }
        }, _callee70, this);
      }));
      function _signoutEnd(_x60) {
        return _signoutEnd2.apply(this, arguments);
      }
      return _signoutEnd;
    }()
    /**
     * Returns promise to trigger a silent request (via an iframe) to the end session endpoint.
     */
  }, {
    key: "signoutSilent",
    value: function () {
      var _signoutSilent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
        var args,
          _a,
          logger2,
          silentRequestTimeoutInSeconds,
          requestArgs,
          id_token_hint,
          url,
          handle,
          _args71 = arguments;
        return _regeneratorRuntime().wrap(function _callee71$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              args = _args71.length > 0 && _args71[0] !== undefined ? _args71[0] : {};
              logger2 = this._logger.create("signoutSilent");
              silentRequestTimeoutInSeconds = args.silentRequestTimeoutInSeconds, requestArgs = _objectWithoutProperties(args, _excluded12);
              if (!this.settings.includeIdTokenInSilentSignout) {
                _context71.next = 15;
                break;
              }
              _context71.next = 6;
              return this._loadUser();
            case 6:
              _context71.t1 = _a = _context71.sent;
              if (!(_context71.t1 == null)) {
                _context71.next = 11;
                break;
              }
              _context71.t2 = void 0;
              _context71.next = 12;
              break;
            case 11:
              _context71.t2 = _a.id_token;
            case 12:
              _context71.t0 = _context71.t2;
              _context71.next = 16;
              break;
            case 15:
              _context71.t0 = void 0;
            case 16:
              id_token_hint = _context71.t0;
              url = this.settings.popup_post_logout_redirect_uri;
              _context71.next = 20;
              return this._iframeNavigator.prepare({
                silentRequestTimeoutInSeconds: silentRequestTimeoutInSeconds
              });
            case 20:
              handle = _context71.sent;
              _context71.next = 23;
              return this._signout(_objectSpread({
                request_type: "so:s",
                post_logout_redirect_uri: url,
                id_token_hint: id_token_hint
              }, requestArgs), handle);
            case 23:
              logger2.info("success");
            case 24:
            case "end":
              return _context71.stop();
          }
        }, _callee71, this);
      }));
      function signoutSilent() {
        return _signoutSilent.apply(this, arguments);
      }
      return signoutSilent;
    }()
    /**
     * Returns promise to notify the parent window of response from the end session endpoint.
     */
  }, {
    key: "signoutSilentCallback",
    value: function () {
      var _signoutSilentCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
        var url,
          logger2,
          _args72 = arguments;
        return _regeneratorRuntime().wrap(function _callee72$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              url = _args72.length > 0 && _args72[0] !== undefined ? _args72[0] : window.location.href;
              logger2 = this._logger.create("signoutSilentCallback");
              _context72.next = 4;
              return this._iframeNavigator.callback(url);
            case 4:
              logger2.info("success");
            case 5:
            case "end":
              return _context72.stop();
          }
        }, _callee72, this);
      }));
      function signoutSilentCallback() {
        return _signoutSilentCallback.apply(this, arguments);
      }
      return signoutSilentCallback;
    }()
  }, {
    key: "revokeTokens",
    value: function () {
      var _revokeTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee73(types) {
        var user;
        return _regeneratorRuntime().wrap(function _callee73$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              _context73.next = 2;
              return this._loadUser();
            case 2:
              user = _context73.sent;
              _context73.next = 5;
              return this._revokeInternal(user, types);
            case 5:
            case "end":
              return _context73.stop();
          }
        }, _callee73, this);
      }));
      function revokeTokens(_x61) {
        return _revokeTokens.apply(this, arguments);
      }
      return revokeTokens;
    }()
  }, {
    key: "_revokeInternal",
    value: function () {
      var _revokeInternal2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee74(user) {
        var types,
          logger2,
          typesPresent,
          _iterator6,
          _step6,
          type,
          _args74 = arguments;
        return _regeneratorRuntime().wrap(function _callee74$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              types = _args74.length > 1 && _args74[1] !== undefined ? _args74[1] : this.settings.revokeTokenTypes;
              logger2 = this._logger.create("_revokeInternal");
              if (user) {
                _context74.next = 4;
                break;
              }
              return _context74.abrupt("return");
            case 4:
              typesPresent = types.filter(function (type) {
                return typeof user[type] === "string";
              });
              if (typesPresent.length) {
                _context74.next = 8;
                break;
              }
              logger2.debug("no need to revoke due to no token(s)");
              return _context74.abrupt("return");
            case 8:
              _iterator6 = _createForOfIteratorHelper(typesPresent);
              _context74.prev = 9;
              _iterator6.s();
            case 11:
              if ((_step6 = _iterator6.n()).done) {
                _context74.next = 19;
                break;
              }
              type = _step6.value;
              _context74.next = 15;
              return this._client.revokeToken(user[type],
              // eslint-disable-line @typescript-eslint/no-non-null-assertion
              type);
            case 15:
              logger2.info("".concat(type, " revoked successfully"));
              if (type !== "access_token") {
                user[type] = null;
              }
            case 17:
              _context74.next = 11;
              break;
            case 19:
              _context74.next = 24;
              break;
            case 21:
              _context74.prev = 21;
              _context74.t0 = _context74["catch"](9);
              _iterator6.e(_context74.t0);
            case 24:
              _context74.prev = 24;
              _iterator6.f();
              return _context74.finish(24);
            case 27:
              _context74.next = 29;
              return this.storeUser(user);
            case 29:
              logger2.debug("user stored");
              this._events.load(user);
            case 31:
            case "end":
              return _context74.stop();
          }
        }, _callee74, this, [[9, 21, 24, 27]]);
      }));
      function _revokeInternal(_x62) {
        return _revokeInternal2.apply(this, arguments);
      }
      return _revokeInternal;
    }()
    /**
     * Enables silent renew for the `UserManager`.
     */
  }, {
    key: "startSilentRenew",
    value: function startSilentRenew() {
      this._logger.create("startSilentRenew");
      void this._silentRenewService.start();
    }
    /**
     * Disables silent renew for the `UserManager`.
     */
  }, {
    key: "stopSilentRenew",
    value: function stopSilentRenew() {
      this._silentRenewService.stop();
    }
  }, {
    key: "_userStoreKey",
    get: function get() {
      return "user:".concat(this.settings.authority, ":").concat(this.settings.client_id);
    }
  }, {
    key: "_loadUser",
    value: function () {
      var _loadUser2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
        var logger2, storageString;
        return _regeneratorRuntime().wrap(function _callee75$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              logger2 = this._logger.create("_loadUser");
              _context75.next = 3;
              return this.settings.userStore.get(this._userStoreKey);
            case 3:
              storageString = _context75.sent;
              if (!storageString) {
                _context75.next = 7;
                break;
              }
              logger2.debug("user storageString loaded");
              return _context75.abrupt("return", _User.fromStorageString(storageString));
            case 7:
              logger2.debug("no user storageString");
              return _context75.abrupt("return", null);
            case 9:
            case "end":
              return _context75.stop();
          }
        }, _callee75, this);
      }));
      function _loadUser() {
        return _loadUser2.apply(this, arguments);
      }
      return _loadUser;
    }()
  }, {
    key: "storeUser",
    value: function () {
      var _storeUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee76(user) {
        var logger2, storageString;
        return _regeneratorRuntime().wrap(function _callee76$(_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              logger2 = this._logger.create("storeUser");
              if (!user) {
                _context76.next = 8;
                break;
              }
              logger2.debug("storing user");
              storageString = user.toStorageString();
              _context76.next = 6;
              return this.settings.userStore.set(this._userStoreKey, storageString);
            case 6:
              _context76.next = 11;
              break;
            case 8:
              this._logger.debug("removing user");
              _context76.next = 11;
              return this.settings.userStore.remove(this._userStoreKey);
            case 11:
            case "end":
              return _context76.stop();
          }
        }, _callee76, this);
      }));
      function storeUser(_x63) {
        return _storeUser.apply(this, arguments);
      }
      return storeUser;
    }()
    /**
     * Removes stale state entries in storage for incomplete authorize requests.
     */
  }, {
    key: "clearStaleState",
    value: function () {
      var _clearStaleState2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
        return _regeneratorRuntime().wrap(function _callee77$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              _context77.next = 2;
              return this._client.clearStaleState();
            case 2:
            case "end":
              return _context77.stop();
          }
        }, _callee77, this);
      }));
      function clearStaleState() {
        return _clearStaleState2.apply(this, arguments);
      }
      return clearStaleState;
    }()
  }]);
  return _UserManager;
}();

// package.json
var version = "2.2.1";

// src/Version.ts
var _Version = version;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AccessTokenEvents: _AccessTokenEvents,
  CheckSessionIFrame: _CheckSessionIFrame,
  ErrorResponse: _ErrorResponse,
  ErrorTimeout: _ErrorTimeout,
  InMemoryWebStorage: _InMemoryWebStorage,
  Log: _Log,
  Logger: _Logger,
  MetadataService: _MetadataService,
  OidcClient: _OidcClient,
  OidcClientSettingsStore: _OidcClientSettingsStore,
  SessionMonitor: _SessionMonitor,
  SigninResponse: _SigninResponse,
  SigninState: _SigninState,
  SignoutResponse: _SignoutResponse,
  State: _State,
  User: _User,
  UserManager: _UserManager,
  UserManagerSettingsStore: _UserManagerSettingsStore,
  Version: _Version,
  WebStorageStateStore: _WebStorageStateStore
});